<template>
    <div class="t-body">
      <div
        id="allrecords"
        data-tilda-export="yes"
        class="t-records"
        data-hook="blocks-collection-content-node"
        data-tilda-project-id="8221338"
        data-tilda-page-id="41674855"
        data-tilda-formskey="e02f08be1debd3ec97b4bcbce8221338"
        data-tilda-cookie="no"
        data-tilda-lazy="yes"
      >
        <div
          id="rec674428398"
          class="r t-rec t-screenmin-980px"
          style="background-color: #000000"
          data-animationappear="off"
          data-record-type="257"
          data-screen-min="980px"
          data-bg-color="#000000"
        >
          <!-- T228 -->
          <div id="nav674428398marker"></div>
          <!-- Header -->
          <div
            id="nav674428398"
            class="t228 t228__positionabsolute"
            style="background-color: rgba(255, 255, 255, 1)"
            data-bgcolor-hex="#ffffff"
            data-bgcolor-rgba="rgba(255,255,255,1)"
            data-navmarker="nav674428398marker"
            data-appearoffset=""
            data-bgopacity-two=""
            data-menushadow=""
            data-bgopacity="1"
            data-menu-items-align="center"
            data-menu="yes"
          >
            <div class="t228__maincontainer" style="">
              <div class="t228__padding40px"></div>
              <div class="t228__leftside">
                <div class="t228__leftcontainer">
                  <a
                    href=""
                    class="t228__imgwrapper"
                    style="color: #ffffff"
                    ><img
                      class="t228__imglogo t228__imglogomobile"
                      src="images/logo_reply.svg"
                      imgfield="img"
                      style="
                        max-width: 158px;
                        width: 158px;
                        min-width: 158px;
                        height: auto;
                        display: block;
                      "
                      alt="Company"
                  /></a>
                </div>
              </div>
              <div class="t228__centerside"></div>
              <div class="t228__rightside">
                <div class="t228__rightcontainer">
                  <div class="t228__right_buttons">
                    <div class="t228__right_buttons_wrap">
                      <div class="t228__right_buttons_but">
                        <div
                          v-if="!isLogged"
                          @click="signUpAndOpenModal"
                          class="t-btn t-btn_md"
                          style="
                            color: #000000;
                            border-radius: 10px;
                            -moz-border-radius: 10px;
                            -webkit-border-radius: 10px;
                          "
                        >
                          <table
                            role="presentation"
                            style="width: 100%; height: 100%"
                          >
                            <tr>
                              <td>Login</td>
                            </tr>
                          </table>
                        </div>
                      </div>
                      <div class="t228__right_buttons_but">
                        <div
                          @click="switchToLogin"
                          class="t-btn t-btn_md"
                          style="
                            color: #ffffff;
                            background-color: #006eff;
                            border-radius: 10px;
                            -moz-border-radius: 10px;
                            -webkit-border-radius: 10px;
                          "
                        >
                          <table style="width: 100%; height: 100%">
                            <tr>
                              <td class="get-link">Sign up free &gt;</td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="t228__padding40px"></div>
            </div>
          </div>
        </div>
        <div
          id="rec676200207"
          class="r t-rec t-screenmax-980px"
          style=""
          data-animationappear="off"
          data-record-type="309"
          data-screen-max="980px"
        >
          <!-- T280 -->
          <div id="nav676200207marker"></div>
          <div
            id="nav676200207"
            class="t280"
            data-menu="yes"
            data-appearoffset=""
          >
            <div class="t280__container t280__positionabsolute" style="">
              <div
                class="t280__container__bg"
                style="background-color: rgba(63, 19, 255, 0)"
                data-bgcolor-hex="#3f13ff"
                data-bgcolor-rgba="rgba(63,19,255,0.0)"
                data-navmarker="nav676200207marker"
                data-appearoffset=""
                data-bgopacity="0.0"
                data-menu-shadow="0px 1px 3px rgba(0,0,0,0.)"
              ></div>
              <div class="t280__menu__content">
                <div class="t280__logo__container" style="min-height: 80px"></div>
                <button
                  type="button"
                  class="t-menuburger t-menuburger_first"
                  aria-label="Навигационное меню"
                  aria-expanded="false"
                >
                  <span style="background-color: #006eff"></span
                  ><span style="background-color: #006eff"></span
                  ><span style="background-color: #006eff"></span
                  ><span style="background-color: #006eff"></span>
                </button>
              </div>
            </div>
            <div class="t280__menu__wrapper">
              <div
                class="t280__menu__bg"
                style="background-color: #ffffff; opacity: 1"
              ></div>
              <div class="t280__menu__container">
                <nav class="t280__menu t-width t-width_6">
                  <ul role="list" class="t280__list t-menu__list">
                    <li class="t280__menu__item">
                      <a
                        class="t280__menu__link t-title t-title_xl t-menu__link-item"
                        href=""
                        data-menu-submenu-hook=""
                        style="color: #000000; font-weight: 300"
                        >Login</a
                      >
                    </li>
                    <li class="t280__menu__item">
                      <a
                        class="t280__menu__link t-title t-title_xl t-menu__link-item get-link"
                        href=""
                        data-menu-submenu-hook=""
                        style="color: #000000; font-weight: 300"
                        >Try it yourself</a
                      >
                    </li>
                  </ul>
                </nav>
                <!-- <div class="t280__bottom t-width t-width_6">
                  <div class="t-sociallinks">
                    <ul
                      role="list"
                      class="t-sociallinks__wrapper"
                      aria-label="Соц. сети"
                    > -->
                      <!-- new soclinks -->
                      <!-- <li
                        class="t-sociallinks__item t-sociallinks__item_facebook"
                      >
                        <a
                          href="/"
                          target="_blank"
                          rel="nofollow"
                          aria-label="facebook"
                          style="width: 30px; height: 30px"
                          ><svg
                            class="t-sociallinks__svg"
                            role="presentation"
                            width="30px"
                            height="30px"
                            viewBox="0 0 100 100"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M50 100c27.6142 0 50-22.3858 50-50S77.6142 0 50 0 0 22.3858 0 50s22.3858 50 50 50Zm3.431-73.9854c-2.5161.0701-5.171.6758-7.0464 2.4577-1.5488 1.4326-2.329 3.5177-2.5044 5.602-.0534 1.4908-.0458 2.9855-.0382 4.4796.0058 1.1205.0115 2.2407-.0085 3.3587-.6888.005-1.3797.0036-2.0709.0021-.9218-.0019-1.8441-.0038-2.7626.0096 0 .8921.0013 1.7855.0026 2.6797.0026 1.791.0052 3.5853-.0026 5.3799.9185.0134 1.8409.0115 2.7627.0096.6912-.0015 1.382-.0029 2.0708.0021.0155 3.5565.0127 7.1128.0098 10.669-.0036 4.4452-.0072 8.8903.0252 13.3354 1.8903-.0134 3.7765-.0115 5.6633-.0095 1.4152.0014 2.8306.0028 4.2484-.0022.0117-4.0009.0088-7.9986.0058-11.9963-.0029-3.9979-.0058-7.9957.0059-11.9964.9533-.005 1.9067-.0036 2.86-.0021 1.2713.0019 2.5425.0038 3.8137-.0096.396-2.679.7335-5.3814.9198-8.0947-1.2576-.0058-2.5155-.0058-3.7734-.0058-1.2578 0-2.5157 0-3.7734-.0059 0-.4689-.0007-.9378-.0014-1.4066-.0022-1.4063-.0044-2.8123.0131-4.2188.198-1.0834 1.3158-1.9104 2.3992-1.8403h5.1476c.0117-2.8069.0117-5.602 0-8.4089-.6636 0-1.3273-.0007-1.9911-.0014-1.9915-.0022-3.9832-.0044-5.975.0131Z"
                              fill="#000000"
                            /></svg
                        ></a>
                      </li> -->
                      <!-- <li class="t-sociallinks__item t-sociallinks__item_twitter">
                        <a
                          href="/"
                          target="_blank"
                          rel="nofollow"
                          aria-label="twitter"
                          style="width: 30px; height: 30px"
                          ><svg
                            class="t-sociallinks__svg"
                            role="presentation"
                            xmlns="http://www.w3.org/2000/svg"
                            width="30px"
                            height="30px"
                            viewBox="0 0 48 48"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48ZM34.7504 12.5L26.1881 22.2389H26.1876L35.5 35.5H28.6512L22.3802 26.57L14.5291 35.5H12.5L21.4794 25.2872L12.5 12.5H19.3488L25.2868 20.9562L32.7214 12.5H34.7504ZM22.4992 24.1266L23.409 25.3999V25.4004L29.6058 34.0733H32.7224L25.1285 23.4448L24.2187 22.1714L18.3768 13.9946H15.2602L22.4992 24.1266Z"
                              fill="#000000"
                            /></svg
                        ></a>
                      </li> -->
                      <!-- <li class="t-sociallinks__item t-sociallinks__item_behance">
                        <a
                          href="/"
                          target="_blank"
                          rel="nofollow"
                          aria-label="behance"
                          style="width: 30px; height: 30px"
                          ><svg
                            class="t-sociallinks__svg"
                            role="presentation"
                            width="30px"
                            height="30px"
                            viewBox="0 0 100 100"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M50 100c27.6142 0 50-22.3858 50-50S77.6142 0 50 0 0 22.3858 0 50s22.3858 50 50 50Zm-1.4722-51.0072c1.0869-.5533 1.9078-1.167 2.4634-1.8412.9991-1.2023 1.4951-2.7852 1.4951-4.7637 0-1.9173-.4897-3.5669-1.4794-4.9411-1.6488-2.2414-4.4411-3.3824-8.38-3.4468H27v32.3572h14.5721c1.6395 0 3.162-.1468 4.5683-.4371 1.4017-.2904 2.6212-.8327 3.6517-1.6246.915-.6843 1.6763-1.5343 2.2892-2.5412.9638-1.5217 1.4378-3.2435 1.4378-5.1631 0-1.8561-.4207-3.4374-1.2612-4.7394-.835-1.3067-2.0836-2.2555-3.7301-2.859Zm-14.066-9.3729h6.0226c1.5476 0 2.8229.1719 3.8196.5062 1.1599.4803 1.7383 1.4794 1.7383 2.9846 0 1.3624-.4363 2.3112-1.3122 2.8449-.8766.5344-2.0138.8021-3.4209.8021h-6.8474v-7.1378Zm10.1153 20.5507c-.7848.3838-1.8717.5674-3.2765.5674h-6.838v-8.6233h6.9455c1.3867.0133 2.469.1938 3.2357.5486 1.371.6239 2.0577 1.7854 2.0577 3.4664 0 1.9926-.7094 3.3354-2.1244 4.0409Zm29.3836-24.827v3.2365H60.9299v-3.2365h13.0308Zm2.9849 10.7282c.9504 1.3797 1.5625 2.976 1.8474 4.7936.1578 1.0587.2284 2.5945.1994 4.602H62.1169c.0934 2.3293.897 3.9585 2.4227 4.8901.9197.5847 2.0349.8703 3.3408.8703 1.3766 0 2.4988-.3484 3.3629-1.0634.4709-.379.886-.9143 1.2447-1.59h6.1857c-.1616 1.3758-.9064 2.7712-2.2453 4.1893-2.0734 2.2539-4.9819 3.384-8.7167 3.384-3.085 0-5.8044-.9527-8.165-2.8519-2.3521-1.9063-3.534-4.9968-3.534-9.285 0-4.0205 1.0611-7.0985 3.1894-9.2402 2.1363-2.1464 4.8933-3.2145 8.2922-3.2145 2.0146 0 3.8298.3602 5.4504 1.0838 1.6151.7244 2.9493 1.8647 4.0009 3.4319Zm-13.0669 1.8098c-.8609.8789-1.3961 2.075-1.6159 3.5881h10.4426c-.1138-1.6104-.6514-2.83-1.6199-3.6627-.9606-.8358-2.1597-1.2549-3.5912-1.2549-1.5578 0-2.7609.4481-3.6156 1.3295Z"
                              fill="#000000"
                            /></svg
                        ></a>
                      </li> -->
                      <!-- <li
                        class="t-sociallinks__item t-sociallinks__item_instagram"
                      >
                        <a
                          href="/"
                          target="_blank"
                          rel="nofollow"
                          aria-label="npm "
                          style="width: 30px; height: 30px"
                          ><svg
                            class="t-sociallinks__svg"
                            role="presentation"
                            width="30px"
                            height="30px"
                            viewBox="0 0 100 100"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100ZM25 39.3918C25 31.4558 31.4566 25 39.3918 25H60.6082C68.5442 25 75 31.4566 75 39.3918V60.8028C75 68.738 68.5442 75.1946 60.6082 75.1946H39.3918C31.4558 75.1946 25 68.738 25 60.8028V39.3918ZM36.9883 50.0054C36.9883 42.8847 42.8438 37.0922 50.0397 37.0922C57.2356 37.0922 63.0911 42.8847 63.0911 50.0054C63.0911 57.1252 57.2356 62.9177 50.0397 62.9177C42.843 62.9177 36.9883 57.1252 36.9883 50.0054ZM41.7422 50.0054C41.7422 54.5033 45.4641 58.1638 50.0397 58.1638C54.6153 58.1638 58.3372 54.5041 58.3372 50.0054C58.3372 45.5066 54.6145 41.8469 50.0397 41.8469C45.4641 41.8469 41.7422 45.5066 41.7422 50.0054ZM63.3248 39.6355C65.0208 39.6355 66.3956 38.2606 66.3956 36.5646C66.3956 34.8687 65.0208 33.4938 63.3248 33.4938C61.6288 33.4938 60.2539 34.8687 60.2539 36.5646C60.2539 38.2606 61.6288 39.6355 63.3248 39.6355Z"
                              fill="#000000"
                            /></svg
                        ></a>
                      </li> -->
                      <!-- /new soclinks -->
                    <!-- </ul> -->
                  <!-- </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div
          id="rec673677530"
          class="r t-rec"
          style=""
          data-animationappear="off"
          data-record-type="396"
        >
          <!-- T396 -->
          <div class="t396">
            <div
              class="t396__artboard"
              data-artboard-recid="673677530"
              data-artboard-screens="320,480,640,960,1200"
              data-artboard-height="730"
              data-artboard-valign="center"
              data-artboard-height_vh="100"
              data-artboard-upscale="grid"
              data-artboard-ovrflw="visible"
              data-artboard-height-res-320="1080"
              data-artboard-height_vh-res-320=""
            >
              <div class="t396__carrier" data-artboard-recid="673677530"></div>
              <div class="t396__filter" data-artboard-recid="673677530"></div>
              <div
                class="t396__elem tn-elem video_zero_block tn-elem__6736775301701622474544"
                data-elem-id="1701622474544"
                data-elem-type="shape"
                data-field-top-value="12"
                data-field-left-value="309"
                data-field-height-value="573"
                data-field-width-value="340"
                data-field-axisy-value="center"
                data-field-axisx-value="center"
                data-field-container-value="window"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value="px"
                data-field-widthunits-value="px"
                data-field-top-res-320-value="228"
                data-field-left-res-320-value="1"
                data-field-height-res-320-value="563"
                data-field-width-res-320-value="252"
                data-field-container-res-320-value="grid"
              >
                <div class="tn-atom"></div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6736775301470209944682 header_text"
                data-elem-id="1470209944682"
                data-elem-type="text"
                data-field-top-value="-168"
                data-field-left-value="-234"
                data-field-width-value="740"
                data-field-axisy-value="center"
                data-field-axisx-value="center"
                data-field-container-value="window"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="-446"
                data-field-left-res-320-value="3"
                data-field-width-res-320-value="306"
                data-field-container-res-320-value="grid"
              >
                <div class="tn-atom" field="tn_text_1470209944682">
                  Help customers instantly with an
                  <span style="color: rgb(0, 111, 255)"
                    >AI-driven chatbot</span
                  >
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6736775301470210011265"
                data-elem-id="1470210011265"
                data-elem-type="text"
                data-field-top-value="46"
                data-field-left-value="-233"
                data-field-width-value="659"
                data-field-axisy-value="center"
                data-field-axisx-value="center"
                data-field-container-value="window"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="-313"
                data-field-left-res-320-value="3"
                data-field-width-res-320-value="268"
                data-field-container-res-320-value="grid"
              >
                <div class="tn-atom" field="tn_text_1470210011265">
                  ChatBot learns from your website, help center, or any documents
                  (doc, pdf, spreadcheets), intelligently providing accurate answers
                  to customer questions based on that knowledge.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6736775301701606787792"
                data-elem-id="1701606787792"
                data-elem-type="form"
                data-field-top-value="240"
                data-field-left-value="-234"
                data-field-width-value="526"
                data-field-axisy-value="center"
                data-field-axisx-value="center"
                data-field-container-value="window"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="-194"
                data-field-left-res-320-value="3"
                data-field-width-res-320-value="302"
                data-field-inputpos-value="h"
                data-field-inputfontfamily-value="TildaSans"
                data-field-fieldfontfamily-value="TildaSans"
                data-field-buttonhoverbgcolor-value="#0f00bc"
                data-field-inputfontsize-value="22"
                data-field-inputfontweight-value="400"
                data-field-inputcolor-value="#000000"
                data-field-inputbgcolor-value="#ffffff"
                data-field-inputbordercolor-value="#000000"
                data-field-inputbordersize-value="1"
                data-field-inputheight-value="70"
                data-field-inputmargbottom-value="20"
                data-field-inputmargright-value="20"
                data-field-inputtitlefontsize-value="16"
                data-field-inputtitlefontweight-value="400"
                data-field-inputtitlecolor-value="#000000"
                data-field-inputtitlemargbottom-value="5"
                data-field-inputelsfontweight-value="400"
                data-field-inputelsfontsize-value="14"
                data-field-buttontitle-value="Sign up free"
                data-field-buttoncolor-value="#ffffff"
                data-field-buttonbgcolor-value="#006eff"
                data-field-buttonradius-value="70"
                data-field-buttonwidth-value="200"
                data-field-buttonheight-value="70"
                data-field-buttonfontfamily-value="TildaSans"
                data-field-buttonfontsize-value="24"
                data-field-buttonfontweight-value="600"
                data-field-inputpos-res-320-value="v"
                data-field-inputfontsize-res-320-value="16"
                data-field-inputheight-res-320-value="40"
                data-field-buttonalign-res-320-value="center"
                data-field-buttonradius-res-320-value="40"
                data-field-buttonheight-res-320-value="40"
                data-field-buttonfontsize-res-320-value="16"
              >
     
                <!--googleoff: all--><!--noindex-->
                <div
                  data-nosnippet="true"
                  class="buy_sending_input"
                
                >
                <div class="tn-atom__inputs-wrapp">
                <div>
                <input
                  type="email"
                  autocomplete="email"
                  name="Email"
                  id="input_1094859299010"
                  class="tilda_input_check"
                  v-model="emailValueTry"
                  placeholder="Enter your business e-mail"
                  style="color: #000000; border: 1px solid #000000; border-radius: 10px;"
                        />
                        <div v-if="show_email" class="show_emails">Invalid email</div>
                      </div>
                        <button @click="switchToReg" class="btn_try get-link">Sign up free</button>
                      </div>
                        <div
                  ref="myElement"
                  class="buy_sending"
                  field="tn_text_1701610209969"
                >
                  Buy sending us your email you agree to our
                  <a class="href_privacy" @click="openPrivacyPolicy">privacy politics</a>
                </div>
                </div>
                <!--/noindex--><!--googleon: all-->
                
              </div>
  
              <div
                class="t396__elem tn-elem tn-elem__6736775301701610209969"
                data-elem-id="1701610209969"
                data-elem-type="text"
                data-field-top-value="287"
                data-field-left-value="-234"
                data-field-width-value="552"
                data-field-axisy-value="center"
                data-field-axisx-value="center"
                data-field-container-value="window"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="-111"
                data-field-left-res-320-value="4"
                data-field-width-res-320-value="221"
                data-field-container-res-320-value="grid"
              >

              </div>
            </div>
          </div>
          <!-- /T396 -->
        </div>
        <div
          id="rec676145274"
          class="r t-rec"
          style=""
          data-animationappear="off"
          data-record-type="131"
        >
          <!-- T123 -->
          <div class="t123">
            <div class="t-container_100">
              <div class="t-width t-width_100">
                <div class="video_source_block">
                  <Animation />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="rec675752982"
          class="r t-rec t-rec_pb_0"
          style="padding-bottom: 0px"
          data-animationappear="off"
          data-record-type="396"
        >
          <!-- T396 -->
          <div class="t396">
            <div
              class="t396__artboard"
              data-artboard-recid="675752982"
              data-artboard-screens="320,480,640,960,1200"
              data-artboard-height="10"
              data-artboard-valign="center"
              data-artboard-upscale="grid"
            >
              <div class="t396__carrier" data-artboard-recid="675752982"></div>
              <div class="t396__filter" data-artboard-recid="675752982"></div>
            </div>
          </div>
          <!-- /T396 -->
        </div>
        <div
          id="rec673703494"
          class="r t-rec t-rec_pt_15"
          style="padding-top: 15px"
          data-animationappear="off"
          data-record-type="396"
        >
          <!-- T396 -->
          <div class="t396">
            <div
              class="t396__artboard"
              data-artboard-recid="673703494"
              data-artboard-screens="320,480,640,960,1200"
              data-artboard-height="1360"
              data-artboard-valign="center"
              data-artboard-upscale="grid"
              data-artboard-height-res-320="1660"
            >
              <div class="t396__carrier" data-artboard-recid="673703494"></div>
              <div class="t396__filter" data-artboard-recid="673703494"></div>
              <div
                class="t396__elem tn-elem tn-elem__6737034941701282519136"
                data-elem-id="1701282519136"
                data-elem-type="text"
                data-field-top-value="106"
                data-field-left-value="200"
                data-field-width-value="800"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="40"
                data-field-left-res-320-value="27"
                data-field-width-res-320-value="267"
              >
                <div class="tn-atom" field="tn_text_1701282519136">
                  Easy-to-Train Chatbot for Your Business Needs
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6737034941701282519137"
                data-elem-id="1701282519137"
                data-elem-type="shape"
                data-field-top-value="462"
                data-field-left-value="80"
                data-field-height-value="229"
                data-field-width-value="341"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value="px"
                data-field-widthunits-value="px"
                data-field-top-res-320-value="339"
                data-field-left-res-320-value="0"
                data-field-height-res-320-value="171"
                data-field-width-res-320-value="320"
              >
                <div class="tn-atom"></div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6737034941701282519140"
                data-elem-id="1701282519140"
                data-elem-type="shape"
                data-field-top-value="462"
                data-field-left-value="439"
                data-field-height-value="229"
                data-field-width-value="359"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value="px"
                data-field-widthunits-value="px"
                data-field-top-res-320-value="549"
                data-field-left-res-320-value="0"
                data-field-height-res-320-value="184"
                data-field-width-res-320-value="320"
              >
                <div class="tn-atom"></div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6737034941701282519143"
                data-elem-id="1701282519143"
                data-elem-type="shape"
                data-field-top-value="462"
                data-field-left-value="815"
                data-field-height-value="229"
                data-field-width-value="341"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value="px"
                data-field-widthunits-value="px"
                data-field-top-res-320-value="856"
                data-field-left-res-320-value="0"
                data-field-height-res-320-value="146"
                data-field-width-res-320-value="320"
              >
                <div class="tn-atom"></div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6737034941701282519146"
                data-elem-id="1701282519146"
                data-elem-type="text"
                data-field-top-value="266"
                data-field-left-value="314"
                data-field-width-value="573"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="150"
                data-field-left-res-320-value="34"
                data-field-width-res-320-value="252"
              >
                <div class="tn-atom" field="tn_text_1701282519146">
                  Make your customer support smarter with our user-friendly
                  chatbot. It’s like teaching a helpful assistant about your
                  business:
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6737034941701282519147"
                data-elem-id="1701282519147"
                data-elem-type="text"
                data-field-top-value="499"
                data-field-left-value="136"
                data-field-width-value="244"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="376"
                data-field-left-res-320-value="44"
              >
                <div class="tn-atom" field="tn_text_1701282519147">
                  <strong>Learn from Your Website:</strong> Our chatbot can use
                  your website’s information to answer customer questions
                  accurately.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6737034941701282519149"
                data-elem-id="1701282519149"
                data-elem-type="text"
                data-field-top-value="913"
                data-field-left-value="80"
                data-field-width-value="206"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="1126"
                data-field-left-res-320-value="32"
                data-field-width-res-320-value="256"
              >
                <div class="tn-atom" field="tn_text_1701282519149">
                  <strong>Better Customer Help:</strong><br /><strong></strong
                  >Offer personalized and knowledgeable support.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6737034941701282519150"
                data-elem-id="1701282519150"
                data-elem-type="text"
                data-field-top-value="499"
                data-field-left-value="487"
                data-field-width-value="272"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="622"
                data-field-left-res-320-value="48"
                data-field-width-res-320-value="250"
              >
                <div class="tn-atom" field="tn_text_1701282519150">
                  <strong>Use Your Files:</strong><br /><strong></strong>It can
                  learn from your PDFs, spreadsheets, and other documents to
                  understand your business better.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6737034941701282519151"
                data-elem-id="1701282519151"
                data-elem-type="text"
                data-field-top-value="913"
                data-field-left-value="406"
                data-field-width-value="248"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="1233"
                data-field-left-res-320-value="55"
                data-field-width-res-320-value="210"
              >
                <div class="tn-atom" field="tn_text_1701282519151">
                  <strong>Save Time:</strong><br /><strong></strong>Less updating
                  needed – the chatbot stays informed from your materials.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6737034941701282519153"
                data-elem-id="1701282519153"
                data-elem-type="text"
                data-field-top-value="499"
                data-field-left-value="869"
                data-field-width-value="272"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="893"
                data-field-left-res-320-value="54"
                data-field-width-res-320-value="231"
              >
                <div class="tn-atom" field="tn_text_1701282519153">
                  <strong>Speak Your Language:</strong><br /><strong></strong>It
                  will communicate in a way that matches your business style.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6737034941701282519154"
                data-elem-id="1701282519154"
                data-elem-type="text"
                data-field-top-value="913"
                data-field-left-value="774"
                data-field-width-value="272"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="1368"
                data-field-left-res-320-value="58"
                data-field-width-res-320-value="204"
              >
                <div class="tn-atom" field="tn_text_1701282519154">
                  <strong>Consistent Quality:</strong><br /><strong></strong>Your
                  business’s unique way of speaking is used in every customer
                  chat.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6737034941701282519155"
                data-elem-id="1701282519155"
                data-elem-type="text"
                data-field-top-value="823"
                data-field-left-value="80"
                data-field-width-value="410"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="1053"
                data-field-left-res-320-value="61"
                data-field-width-res-320-value="198"
              >
                <div class="tn-atom" field="tn_text_1701282519155">Benefits:</div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6737034941701282519157"
                data-elem-id="1701282519157"
                data-elem-type="text"
                data-field-top-value="1124"
                data-field-left-value="80"
                data-field-width-value="850"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="1528"
                data-field-left-res-320-value="10"
                data-field-width-res-320-value="301"
              >
                <div class="tn-atom" field="tn_text_1701282519157">
                  Get a chatbot that grows with your business
                  <strong style="font-weight: 700; color: rgb(51, 51, 51)"
                    >|</strong
                  >
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6737034941701282519158"
                data-elem-id="1701282519158"
                data-elem-type="image"
                data-field-top-value="400"
                data-field-left-value="168"
                data-field-width-value="187"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="1080"
                data-field-fileheight-value="423"
                data-field-top-res-320-value="295"
                data-field-left-res-320-value="90"
                data-field-width-res-320-value="141"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild3865-3365-4132-b634-373364613061__untitled-3.png"
                    alt=""
                    imgfield="tn_img_1701282519158"
                  />
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6737034941701282519162"
                data-elem-id="1701282519162"
                data-elem-type="image"
                data-field-top-value="367"
                data-field-left-value="565"
                data-field-width-value="94"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="900"
                data-field-fileheight-value="1060"
                data-field-top-res-320-value="531"
                data-field-left-res-320-value="125"
                data-field-width-res-320-value="70"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild3538-3137-4537-a364-613331313030__pdf.png"
                    alt=""
                    imgfield="tn_img_1701282519162"
                  />
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6737034941701282519164"
                data-elem-id="1701282519164"
                data-elem-type="image"
                data-field-top-value="374"
                data-field-left-value="920"
                data-field-width-value="146"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="1426"
                data-field-fileheight-value="1065"
                data-field-top-res-320-value="801"
                data-field-left-res-320-value="110"
                data-field-width-res-320-value="100"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild6466-6161-4263-a439-373636373231__language.png"
                    alt=""
                    imgfield="tn_img_1701282519164"
                  />
                </div>
              </div>
            </div>
          </div>
  
          <!-- /T396 -->
        </div>
        <div
          id="rec674576180"
          class="r t-rec"
          style=""
          data-animationappear="off"
          data-record-type="635"
        >
          <!-- t635 -->
          <div
            class="t635__textholder"
            data-recid="673703494"
            data-text1="and makes customer support easier."
          ></div>
        </div>
        <div
          id="rec675753165"
          class="r t-rec t-rec_pb_0"
          style="padding-bottom: 0px"
          data-animationappear="off"
          data-record-type="396"
        >
          <!-- T396 -->
          <div class="t396">
            <div
              class="t396__artboard"
              data-artboard-recid="675753165"
              data-artboard-screens="320,480,640,960,1200"
              data-artboard-height="10"
              data-artboard-valign="center"
              data-artboard-upscale="grid"
            >
              <div class="t396__carrier" data-artboard-recid="675753165"></div>
              <div class="t396__filter" data-artboard-recid="675753165"></div>
            </div>
          </div>
  
          <!-- /T396 -->
        </div>
        <div
          id="rec673837976"
          class="r t-rec"
          style=""
          data-animationappear="off"
          data-record-type="396"
        >
          <!-- T396 -->
          <div class="t396">
            <div
              class="t396__artboard"
              data-artboard-recid="673837976"
              data-artboard-screens="320,480,640,960,1200"
              data-artboard-height="1060"
              data-artboard-valign="center"
              data-artboard-upscale="grid"
              data-artboard-height-res-320="1350"
            >
              <div class="t396__carrier" data-artboard-recid="673837976"></div>
              <div class="t396__filter" data-artboard-recid="673837976"></div>
              <div
                class="t396__elem tn-elem tn-elem__6738379761701287493889"
                data-elem-id="1701287493889"
                data-elem-type="text"
                data-field-top-value="105"
                data-field-left-value="80"
                data-field-width-value="1021"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="37"
                data-field-left-res-320-value="68"
                data-field-width-res-320-value="184"
              >
                <div class="tn-atom" field="tn_text_1701287493889">
                  Solving Real Business Challenges
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738379761701287493905"
                data-elem-id="1701287493905"
                data-elem-type="text"
                data-field-top-value="209"
                data-field-left-value="80"
                data-field-width-value="433"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
              >
                <div class="tn-atom" field="tn_text_1701287493905"></div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738379761701287493903"
                data-elem-id="1701287493903"
                data-elem-type="text"
                data-field-top-value="785"
                data-field-left-value="80"
                data-field-width-value="334"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="924"
                data-field-left-res-320-value="10"
                data-field-width-res-320-value="301"
              >
                <div class="tn-atom" field="tn_text_1701287493903">
                  <strong>Automated Knowledge Updates</strong><br />Always in the
                  loop, your chatbot keeps its knowledge fresh and up-to-date by
                  automatically integrating your latest materials, ensuring your
                  customers receive the most current information.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738379761701287493906"
                data-elem-id="1701287493906"
                data-elem-type="text"
                data-field-top-value="402"
                data-field-left-value="479"
                data-field-width-value="305"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="461"
                data-field-left-res-320-value="9"
              >
                <div class="tn-atom" field="tn_text_1701287493906">
                  <strong>Ensuring Consistent Support</strong><br />Consistency is
                  key, and your chatbot has it in spades. Trained on your specific
                  materials, it provides accurate, reliable responses every time –
                  like your most dependable team member.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738379761701287493907"
                data-elem-id="1701287493907"
                data-elem-type="text"
                data-field-top-value="782"
                data-field-left-value="479"
                data-field-width-value="333"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="1170"
                data-field-left-res-320-value="10"
                data-field-width-res-320-value="301"
              >
                <div class="tn-atom" field="tn_text_1701287493907">
                  <strong>Enhancing Customer Engagement</strong><br />Consistency
                  is key, and your chatbot has it in spades. Trained on your
                  specific materials, it provides accurate, reliable responses
                  every time – like your most dependable team member.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738379761701287493908"
                data-elem-id="1701287493908"
                data-elem-type="text"
                data-field-top-value="399"
                data-field-left-value="862"
                data-field-width-value="318"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="701"
                data-field-left-res-320-value="9"
                data-field-width-res-320-value="303"
              >
                <div class="tn-atom" field="tn_text_1701287493908">
                  <strong>Minimizing Training Time</strong><br />Forget the long
                  training hours. Your chatbot comes ready, equipped with
                  knowledge from your existing resources, saving you time and
                  effort from day one.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738379761701287493910"
                data-elem-id="1701287493910"
                data-elem-type="image"
                data-field-top-value="316"
                data-field-left-value="598"
                data-field-width-value="67"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="613"
                data-field-fileheight-value="640"
                data-field-top-res-320-value="400"
                data-field-left-res-320-value="140"
                data-field-width-res-320-value="42"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild6532-3362-4036-a332-393330336461__rock_emoji.png"
                    alt=""
                    imgfield="tn_img_1701287493910"
                  />
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738379761701328860259"
                data-elem-id="1701328860259"
                data-elem-type="image"
                data-field-top-value="699"
                data-field-left-value="214"
                data-field-width-value="67"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="610"
                data-field-fileheight-value="640"
                data-field-top-res-320-value="863"
                data-field-left-res-320-value="144"
                data-field-width-res-320-value="42"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild6465-6538-4430-b661-656265303538___robot_emoji_free_do.png"
                    alt=""
                    imgfield="tn_img_1701328860259"
                  />
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738379761701287493890"
                data-elem-id="1701287493890"
                data-elem-type="text"
                data-field-top-value="394"
                data-field-left-value="80"
                data-field-width-value="321"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="215"
                data-field-left-res-320-value="11"
                data-field-width-res-320-value="301"
              >
                <div class="tn-atom" field="tn_text_1701287493890">
                  <strong>Reducing Inbox Overload</strong><br />Imagine a world
                  where your inbox is no longer swamped with customer queries.
                  Your new chatbot steps in to answer common questions, lightening
                  the load for you and your team.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738379761701329241888"
                data-elem-id="1701329241888"
                data-elem-type="image"
                data-field-top-value="699"
                data-field-left-value="612"
                data-field-width-value="67"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="640"
                data-field-fileheight-value="640"
                data-field-top-res-320-value="1108"
                data-field-left-res-320-value="143"
                data-field-width-res-320-value="42"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild3535-6361-4161-b364-656463373564__people_emoji_-_unkno.png"
                    alt=""
                    imgfield="tn_img_1701329241888"
                  />
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738379761701329249122"
                data-elem-id="1701329249122"
                data-elem-type="image"
                data-field-top-value="316"
                data-field-left-value="988"
                data-field-width-value="67"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="640"
                data-field-fileheight-value="640"
                data-field-top-res-320-value="644"
                data-field-left-res-320-value="147"
                data-field-width-res-320-value="42"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild3231-6662-4165-a233-363430306664__nerd_emoji_free_down.png"
                    alt=""
                    imgfield="tn_img_1701329249122"
                  />
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738379761701328900415"
                data-elem-id="1701328900415"
                data-elem-type="image"
                data-field-top-value="316"
                data-field-left-value="207"
                data-field-width-value="67"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="640"
                data-field-fileheight-value="594"
                data-field-top-res-320-value="161"
                data-field-left-res-320-value="140"
                data-field-width-res-320-value="42"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild3633-6164-4632-b466-626635343037__star_eyes_emoji.png"
                    alt=""
                    imgfield="tn_img_1701328900415"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- /T396 -->
        </div>
        <div
          id="rec675753174"
          class="r t-rec t-rec_pb_0"
          style="padding-bottom: 0px"
          data-animationappear="off"
          data-record-type="396"
        >
          <!-- T396 -->
          <div class="t396">
            <div
              class="t396__artboard"
              data-artboard-recid="675753174"
              data-artboard-screens="320,480,640,960,1200"
              data-artboard-height="10"
              data-artboard-valign="center"
              data-artboard-upscale="grid"
            >
              <div class="t396__carrier" data-artboard-recid="675753174"></div>
              <div class="t396__filter" data-artboard-recid="675753174"></div>
            </div>
          </div>
          <!-- /T396 -->
        </div>
        <div
          id="rec673845808"
          class="r t-rec"
          style=""
          data-animationappear="off"
          data-record-type="396"
        >
          <!-- T396 -->
          <div class="t396">
            <div
              class="t396__artboard"
              data-artboard-recid="673845808"
              data-artboard-screens="320,480,640,960,1200"
              data-artboard-height="980"
              data-artboard-valign="center"
              data-artboard-upscale="grid"
              data-artboard-height-res-320="1450"
            >
              <div class="t396__carrier" data-artboard-recid="673845808"></div>
              <div class="t396__filter" data-artboard-recid="673845808"></div>
              <div
                class="t396__elem tn-elem tn-elem__6738458081470209944682"
                data-elem-id="1470209944682"
                data-elem-type="text"
                data-field-top-value="85"
                data-field-left-value="80"
                data-field-width-value="800"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="33"
                data-field-left-res-320-value="11"
                data-field-width-res-320-value="300"
              >
                <div class="tn-atom" field="tn_text_1470209944682">
                  Get Started in Three Simple Steps
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738458081701175709584"
                data-elem-id="1701175709584"
                data-elem-type="text"
                data-field-top-value="632"
                data-field-left-value="80"
                data-field-width-value="317"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="395"
                data-field-left-res-320-value="10"
                data-field-width-res-320-value="302"
              >
                <div class="tn-atom" field="tn_text_1701175709584">
                  <strong>Set Up Your Chatbot</strong><br />Simply give the
                  chatbot your website address or upload your documents. Our
                  chatbot learns everything it needs to know about your business
                  from these.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738458081701175723418"
                data-elem-id="1701175723418"
                data-elem-type="text"
                data-field-top-value="632"
                data-field-left-value="460"
                data-field-width-value="325"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="832"
                data-field-left-res-320-value="10"
                data-field-width-res-320-value="301"
              >
                <div class="tn-atom" field="tn_text_1701175723418">
                  <strong>Easy Integration</strong><br />We provide you with a
                  small piece of code. Copy and paste it onto your website, and
                  voilà – your chatbot is live and ready to interact with
                  customers!
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738458081701329430713"
                data-elem-id="1701329430713"
                data-elem-type="text"
                data-field-top-value="550"
                data-field-left-value="80"
                data-field-width-value="111"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="346"
                data-field-left-res-320-value="105"
              >
                <div class="tn-atom" field="tn_text_1701329430713">Step 1</div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738458081701164471399"
                data-elem-id="1701164471399"
                data-elem-type="text"
                data-field-top-value="632"
                data-field-left-value="843"
                data-field-width-value="279"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="1287"
                data-field-left-res-320-value="21"
              >
                <div class="tn-atom" field="tn_text_1701164471399">
                  <strong>Keep Improving</strong><br />As your business grows and
                  changes, so does your chatbot. Easily update its knowledge with
                  new information anytime.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738458081701329437802"
                data-elem-id="1701329437802"
                data-elem-type="text"
                data-field-top-value="550"
                data-field-left-value="460"
                data-field-width-value="129"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="784"
                data-field-left-res-320-value="96"
              >
                <div class="tn-atom" field="tn_text_1701329437802">Step 2</div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738458081701329397692"
                data-elem-id="1701329397692"
                data-elem-type="text"
                data-field-top-value="550"
                data-field-left-value="843"
                data-field-width-value="129"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="1239"
                data-field-left-res-320-value="96"
              >
                <div class="tn-atom" field="tn_text_1701329397692">Step 3</div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738458081701329719794"
                data-elem-id="1701329719794"
                data-elem-type="image"
                data-field-top-value="566"
                data-field-left-value="206"
                data-field-width-value="233"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="818"
                data-field-fileheight-value="50"
                data-field-top-res-320-value="132"
                data-field-left-res-320-value="811"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild3634-3733-4361-b165-373061306339__untitled-1.png"
                    alt=""
                    imgfield="tn_img_1701329719794"
                  />
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738458081701329671387"
                data-elem-id="1701329671387"
                data-elem-type="image"
                data-field-top-value="566"
                data-field-left-value="596"
                data-field-width-value="233"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="818"
                data-field-fileheight-value="50"
                data-field-top-res-320-value="177"
                data-field-left-res-320-value="827"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild3634-3733-4361-b165-373061306339__untitled-1.png"
                    alt=""
                    imgfield="tn_img_1701329671387"
                  />
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738458081701603119792"
                data-elem-id="1701603119792"
                data-elem-type="image"
                data-field-top-value="294"
                data-field-left-value="80"
                data-field-width-value="339"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="1080"
                data-field-fileheight-value="720"
                data-field-top-res-320-value="124"
                data-field-left-res-320-value="11"
                data-field-width-res-320-value="300"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild3935-6163-4630-b033-636433353635__artboard_1.png"
                    alt=""
                    imgfield="tn_img_1701603119792"
                  />
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738458081701603168242"
                data-elem-id="1701603168242"
                data-elem-type="image"
                data-field-top-value="294"
                data-field-left-value="460"
                data-field-width-value="339"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="1080"
                data-field-fileheight-value="720"
                data-field-top-res-320-value="565"
                data-field-left-res-320-value="10"
                data-field-width-res-320-value="301"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild3730-6137-4530-b466-643264333239__artboard_1_copy.png"
                    alt=""
                    imgfield="tn_img_1701603168242"
                  />
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738458081701603257656"
                data-elem-id="1701603257656"
                data-elem-type="image"
                data-field-top-value="294"
                data-field-left-value="843"
                data-field-width-value="339"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="1080"
                data-field-fileheight-value="720"
                data-field-top-res-320-value="1016"
                data-field-left-res-320-value="10"
                data-field-width-res-320-value="301"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild3538-6434-4339-a133-393835623666__artboard_1_copy_2.png"
                    alt=""
                    imgfield="tn_img_1701603257656"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- /T396 -->
        </div>
        <div
          id="rec673846437"
          class="r t-rec"
          style=""
          data-animationappear="off"
          data-record-type="396"
        >
          <!-- T396 -->
          <div class="t396">
            <div
              class="t396__artboard"
              data-artboard-recid="673846437"
              data-artboard-screens="320,480,640,960,1200"
              data-artboard-height="330"
              data-artboard-valign="center"
              data-artboard-upscale="grid"
              data-artboard-height-res-320="250"
            >
              <div class="t396__carrier" data-artboard-recid="673846437"></div>
              <div class="t396__filter" data-artboard-recid="673846437"></div>
              <div
                class="t396__elem tn-elem tn-elem__6738464371701330031869"
                data-elem-id="1701330031869"
                data-elem-type="text"
                data-field-top-value="42"
                data-field-left-value="257"
                data-field-width-value="686"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="19"
                data-field-left-res-320-value="26"
                data-field-width-res-320-value="268"
              >
                <div class="tn-atom" field="tn_text_1701330031869">
                  Title - <strong>Resolve up to 80% of customer questions </strong
                  ><strong style="color: rgb(255, 245, 3)">with AI</strong>
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738464371701604543322"
                data-elem-id="1701604543322"
                data-elem-type="text"
                data-field-top-value="205"
                data-field-left-value="433"
                data-field-width-value="518"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="158"
                data-field-left-res-320-value="63"
                data-field-width-res-320-value="225"
              >
                <div class="tn-atom" field="tn_text_1701604543322">
                  Free 7-day trial<br />No credit card required
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738464371701604624978"
                data-elem-id="1701604624978"
                data-elem-type="image"
                data-field-top-value="213"
                data-field-left-value="380"
                data-field-width-value="35"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="72"
                data-field-fileheight-value="72"
                data-field-top-res-320-value="167"
                data-field-left-res-320-value="32"
                data-field-width-res-320-value="24"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild6365-3365-4136-a262-656432636661__check_ring.png"
                    alt=""
                    imgfield="tn_img_1701604624978"
                  />
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738464371701604669036"
                data-elem-id="1701604669036"
                data-elem-type="image"
                data-field-top-value="263"
                data-field-left-value="380"
                data-field-width-value="35"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="72"
                data-field-fileheight-value="72"
                data-field-top-res-320-value="212"
                data-field-left-res-320-value="31"
                data-field-width-res-320-value="24"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild6632-6465-4330-b038-626661313664__check_ring.png"
                    alt=""
                    imgfield="tn_img_1701604669036"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- /T396 -->
        </div>
        <div
          id="rec676036513"
          class="r t-rec t-rec_pt_0 t-rec_pb_90"
          style="
            padding-top: 0px;
            padding-bottom: 90px;
            background-color: #006eff;
          "
          data-record-type="1045"
          data-bg-color="#006eff"
        >
          <!-- T186 -->
          <div class="t1045">
            <div class="t-container">
              <div class="t1045__input-wrapper t-col t-col_8 t-prefix_2">
                <form
                  id="form676036513"
                  name="form676036513"
                  role="form"
                  action=""
                  method="POST"
                  data-formactiontype="0"
                  data-inputbox=".t-input-group"
                  class="t-form js-form-proccess t-form_inputs-total_1"
                  data-success-callback="t1045_onSuccess"
                >
                  <!-- NO ONE SERVICES CONNECTED -->
                  <div
                    class="js-successbox t-form__successbox t-text t-text_md"
                    aria-live="polite"
                    style="display: none"
                    data-success-message="Well done! we will contact you soon."
                  ></div>
                  <!-- TODO: изменить класс на t-form__inputsbox_flex -->
                  <div class="t-form__inputsbox">
                    <div
                      class="t-input-group t-input-group_em"
                      data-input-lid="1094859299010"
                    >
                      <div class="t-input-block">
                        <div>
                        <input
                          type="email"
                          autocomplete="email"
                          name="Email"
                          id="input_1094859299010"
                          class="t-input js-tilda-rule"
                          v-model="emailValueTry"
                          placeholder="Enter your business e-mail"
                          data-tilda-rule="email"
                          aria-describedby="error_1094859299010"
                          style="color: #000000; border: 1px solid #000000; border-radius: 10px;"
                        />
                        <div v-if="false_email" class="false_emails">Invalid email</div>
                      </div>
                        <div
                          class="t-input-error"
                          aria-live="polite"
                          id="error_1094859299010"
                        ></div>
                      </div>
                    </div>
                    <div class="t-form__errorbox-middle"
                    >
                      <!--noindex-->
                      <div
                   
                        class="js-errorbox-all t-form__errorbox-wrapper"
                        style="display: none"
                        data-nosnippet
                        tabindex="-1"
                        aria-label="Ошибки при заполнении формы"
                      >
                        <ul
                          role="list"
                          class="t-form__errorbox-text t-text t-text_md"
                        >
                          <li
                            class="t-form__errorbox-item js-rule-error js-rule-error-all"
                          ></li>
                          <li
                            class="t-form__errorbox-item js-rule-error js-rule-error-req"
                          ></li>
                          <li
                            class="t-form__errorbox-item js-rule-error js-rule-error-email"
                          ></li>
                          <li
                            class="t-form__errorbox-item js-rule-error js-rule-error-name"
                          ></li>
                          <li
                            class="t-form__errorbox-item js-rule-error js-rule-error-phone"
                          ></li>
                          <li
                            class="t-form__errorbox-item js-rule-error js-rule-error-minlength"
                          ></li>
                          <li
                            class="t-form__errorbox-item js-rule-error js-rule-error-string"
                          ></li>
                        </ul>
                      </div>
                      <!--/noindex-->
                    </div>
                    <div class="t-form__submit">
                      <button
                      @click="switchToReg"
                  
                        class="t-submit get-link"
                        style="
                          color: #ffffff;
                          background-color: #000000;
                          border-radius: 10px;
                          -moz-border-radius: 10px;
                          -webkit-border-radius: 10px;
                        "
                        data-field="buttontitle"
                      >
                        Sign up free
                      </button>
                    </div>
                  </div>
     
                </form>
                <div
                  class="t1045__form-bottom-text t-text t-text_xs"
                  field="text"
                >
                
                  <span style="color: rgb(255, 255, 255)"
                    >Buy sending us your email you agree to our <a class="href_policy" @click="openPrivacyPolicy"> privacy
                    politics </a></span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="rec673847246"
          class="r t-rec"
          style=""
          data-animationappear="off"
          data-record-type="396"
        >
          <!-- T396 -->
          <div class="t396">
            <div
              class="t396__artboard"
              data-artboard-recid="673847246"
              data-artboard-screens="320,480,640,960,1200"
              data-artboard-height="850"
              data-artboard-valign="center"
              data-artboard-upscale="grid"
              data-artboard-height-res-320="970"
            >
              <div class="t396__carrier" data-artboard-recid="673847246"></div>
              <div class="t396__filter" data-artboard-recid="673847246"></div>
              <div
                class="t396__elem tn-elem tn-elem__6738472461470209944682"
                data-elem-id="1470209944682"
                data-elem-type="text"
                data-field-top-value="106"
                data-field-left-value="80"
                data-field-width-value="931"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="32"
                data-field-left-res-320-value="12"
                data-field-width-res-320-value="299"
              >
                <div class="tn-atom" field="tn_text_1470209944682">
                  Customize to Fit Your Brand
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738472461701175709584"
                data-elem-id="1701175709584"
                data-elem-type="text"
                data-field-top-value="507"
                data-field-left-value="80"
                data-field-width-value="261"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="284"
                data-field-left-res-320-value="10"
                data-field-width-res-320-value="301"
              >
                <div class="tn-atom" field="tn_text_1701175709584">
                  <strong>Match Your Brand’s Tone</strong><br /><strong></strong
                  >Whether your brand is friendly, professional, or quirky, our
                  chatbot adapts to your style.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738472461701164464731"
                data-elem-id="1701164464731"
                data-elem-type="text"
                data-field-top-value="247"
                data-field-left-value="80"
                data-field-width-value="607"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="100"
                data-field-left-res-320-value="11"
                data-field-width-res-320-value="301"
              >
                <div class="tn-atom" field="tn_text_1701164464731">
                  Your business is unique, and so should be your customer support.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738472461701175723418"
                data-elem-id="1701175723418"
                data-elem-type="text"
                data-field-top-value="507"
                data-field-left-value="390"
                data-field-width-value="240"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="447"
                data-field-left-res-320-value="11"
                data-field-width-res-320-value="300"
              >
                <div class="tn-atom" field="tn_text_1701175723418">
                  <strong>Specific Answers for Your Products</strong
                  ><br /><strong></strong>Teach the chatbot details about your
                  products or services for accurate, tailored responses.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738472461701176417265"
                data-elem-id="1701176417265"
                data-elem-type="text"
                data-field-top-value="507"
                data-field-left-value="679"
                data-field-width-value="217"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="627"
                data-field-left-res-320-value="11"
                data-field-width-res-320-value="300"
              >
                <div class="tn-atom" field="tn_text_1701176417265">
                  <strong>Update Anytime</strong><br /><strong></strong>Change or
                  add new information easily, keeping your chatbot as up-to-date
                  as your business.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738472461701164471399"
                data-elem-id="1701164471399"
                data-elem-type="text"
                data-field-top-value="507"
                data-field-left-value="945"
                data-field-width-value="217"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="821"
                data-field-left-res-320-value="10"
                data-field-width-res-320-value="301"
              >
                <div class="tn-atom" field="tn_text_1701164471399">
                  <strong>Q&amp;A Training</strong><br /><strong> </strong>Use
                  real chat history to refine and improve your chatbot by
                  providing feedback that allows it to improve with every
                  interaction.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738472461701605387336"
                data-elem-id="1701605387336"
                data-elem-type="image"
                data-field-top-value="430"
                data-field-left-value="390"
                data-field-width-value="52"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="96"
                data-field-fileheight-value="96"
                data-field-top-res-320-value="405"
                data-field-left-res-320-value="144"
                data-field-width-res-320-value="32"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild3933-6139-4539-b965-626339323035__chat_fill.png"
                    alt=""
                    imgfield="tn_img_1701605387336"
                  />
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738472461701605396383"
                data-elem-id="1701605396383"
                data-elem-type="image"
                data-field-top-value="430"
                data-field-left-value="81"
                data-field-width-value="52"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="96"
                data-field-fileheight-value="96"
                data-field-top-res-320-value="237"
                data-field-left-res-320-value="144"
                data-field-width-res-320-value="32"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild3037-6330-4365-b065-313937363833__check_fill.png"
                    alt=""
                    imgfield="tn_img_1701605396383"
                  />
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738472461701605406001"
                data-elem-id="1701605406001"
                data-elem-type="image"
                data-field-top-value="430"
                data-field-left-value="952"
                data-field-width-value="52"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="96"
                data-field-fileheight-value="96"
                data-field-top-res-320-value="775"
                data-field-left-res-320-value="144"
                data-field-width-res-320-value="32"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild6366-3164-4930-a266-363038633330__edit_fill.png"
                    alt=""
                    imgfield="tn_img_1701605406001"
                  />
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738472461701605412885"
                data-elem-id="1701605412885"
                data-elem-type="image"
                data-field-top-value="430"
                data-field-left-value="679"
                data-field-width-value="52"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="96"
                data-field-fileheight-value="96"
                data-field-top-res-320-value="583"
                data-field-left-res-320-value="144"
                data-field-width-res-320-value="32"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild6439-3762-4538-a163-366632306464__time_fill.png"
                    alt=""
                    imgfield="tn_img_1701605412885"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- /T396 -->
        </div>
        <div
          id="rec675753187"
          class="r t-rec t-rec_pb_0"
          style="padding-bottom: 0px"
          data-animationappear="off"
          data-record-type="396"
        >
          <!-- T396 -->
          <div class="t396">
            <div
              class="t396__artboard"
              data-artboard-recid="675753187"
              data-artboard-screens="320,480,640,960,1200"
              data-artboard-height="10"
              data-artboard-valign="center"
              data-artboard-upscale="grid"
            >
              <div class="t396__carrier" data-artboard-recid="675753187"></div>
              <div class="t396__filter" data-artboard-recid="675753187"></div>
            </div>
          </div>
          <!-- /T396 -->
        </div>
        <div
          id="rec673848691"
          class="r t-rec"
          style=""
          data-animationappear="off"
          data-record-type="396"
        >
          <!-- T396 -->
          <div class="t396">
            <div
              class="t396__artboard"
              data-artboard-recid="673848691"
              data-artboard-screens="320,480,640,960,1200"
              data-artboard-height="2240"
              data-artboard-valign="center"
              data-artboard-upscale="grid"
              data-artboard-height-res-320="1440"
            >
              <div class="t396__carrier" data-artboard-recid="673848691"></div>
              <div class="t396__filter" data-artboard-recid="673848691"></div>
              <div
                class="t396__elem tn-elem tn-elem__6738486911470209944682"
                data-elem-id="1470209944682"
                data-elem-type="text"
                data-field-top-value="59"
                data-field-left-value="80"
                data-field-width-value="931"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="32"
                data-field-left-res-320-value="44"
                data-field-width-res-320-value="233"
              >
                <div class="tn-atom" field="tn_text_1470209944682">
                  Grow Smarter with Valuable Insights
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738486911701175709584"
                data-elem-id="1701175709584"
                data-elem-type="text"
                data-field-top-value="433"
                data-field-left-value="120"
                data-field-width-value="261"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="504"
                data-field-left-res-320-value="30"
              >
                <div class="tn-atom" field="tn_text_1701175709584">
                  <strong>Track Performance</strong><br />See how well the chatbot
                  is handling queries and where it can improve.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738486911701164464731"
                data-elem-id="1701164464731"
                data-elem-type="text"
                data-field-top-value="231"
                data-field-left-value="80"
                data-field-width-value="781"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="110"
                data-field-left-res-320-value="10"
                data-field-width-res-320-value="302"
              >
                <div class="tn-atom" field="tn_text_1701164464731">
                  Our chatbot doesn't just answer questions; it helps you
                  understand your customers better.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738486911701175723418"
                data-elem-id="1701175723418"
                data-elem-type="text"
                data-field-top-value="1007"
                data-field-left-value="846"
                data-field-width-value="252"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="872"
                data-field-left-res-320-value="34"
              >
                <div class="tn-atom" field="tn_text_1701175723418">
                  <strong>Understand Your Customers</strong><br /><strong></strong
                  >Get reports on common questions and customer needs, helping you
                  make informed business decisions.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738486911701176417265"
                data-elem-id="1701176417265"
                data-elem-type="text"
                data-field-top-value="1591"
                data-field-left-value="122"
                data-field-width-value="259"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="1285"
                data-field-left-res-320-value="25"
              >
                <div class="tn-atom" field="tn_text_1701176417265">
                  <strong>Continuously Improve</strong><br />Use insights to
                  refine your chatbot, making it more helpful and efficient over
                  time.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738486911701332169204"
                data-elem-id="1701332169204"
                data-elem-type="image"
                data-field-top-value="433"
                data-field-left-value="420"
                data-field-width-value="717"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="1608"
                data-field-fileheight-value="1144"
                data-field-top-res-320-value="270"
                data-field-left-res-320-value="10"
                data-field-width-res-320-value="300"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild3462-3963-4361-b863-366361633366____2023-11-30__111359.png"
                    alt=""
                    imgfield="tn_img_1701332169204"
                  />
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738486911701332185740"
                data-elem-id="1701332185740"
                data-elem-type="image"
                data-field-top-value="1007"
                data-field-left-value="80"
                data-field-width-value="717"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="1608"
                data-field-fileheight-value="1144"
                data-field-top-res-320-value="637"
                data-field-left-res-320-value="10"
                data-field-width-res-320-value="300"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild6234-6462-4464-b463-313838666238____2023-11-30__111607.png"
                    alt=""
                    imgfield="tn_img_1701332185740"
                  />
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738486911701332028869"
                data-elem-id="1701332028869"
                data-elem-type="image"
                data-field-top-value="1591"
                data-field-left-value="419"
                data-field-width-value="717"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="1602"
                data-field-fileheight-value="1230"
                data-field-top-res-320-value="1026"
                data-field-left-res-320-value="10"
                data-field-width-res-320-value="300"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild3436-6339-4434-a334-306235613935____2023-11-30__111810.png"
                    alt=""
                    imgfield="tn_img_1701332028869"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- /T396 -->
        </div>
        <div
          id="rec675753199"
          class="r t-rec t-rec_pb_0"
          style="padding-bottom: 0px"
          data-animationappear="off"
          data-record-type="396"
        >
          <!-- T396 -->
          <div class="t396">
            <div
              class="t396__artboard"
              data-artboard-recid="675753199"
              data-artboard-screens="320,480,640,960,1200"
              data-artboard-height="10"
              data-artboard-valign="center"
              data-artboard-upscale="grid"
            >
              <div class="t396__carrier" data-artboard-recid="675753199"></div>
              <div class="t396__filter" data-artboard-recid="675753199"></div>
            </div>
          </div>
          <!-- /T396 -->
        </div>
        <div
          id="rec673852235"
          class="r t-rec"
          style=""
          data-animationappear="off"
          data-record-type="396"
        >
          <!-- T396 -->
          <div class="t396">
            <div
              class="t396__artboard"
              data-artboard-recid="673852235"
              data-artboard-screens="320,480,640,960,1200"
              data-artboard-height="880"
              data-artboard-valign="center"
              data-artboard-upscale="grid"
              data-artboard-height-res-320="790"
            >
              <div class="t396__carrier" data-artboard-recid="673852235"></div>
              <div class="t396__filter" data-artboard-recid="673852235"></div>
              <div
                class="t396__elem tn-elem tn-elem__6738522351701332885841"
                data-elem-id="1701332885841"
                data-elem-type="shape"
                data-field-top-value="451"
                data-field-left-value="80"
                data-field-height-value="229"
                data-field-width-value="341"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value="px"
                data-field-widthunits-value="px"
                data-field-top-res-320-value="225"
                data-field-left-res-320-value="0"
                data-field-height-res-320-value="176"
                data-field-width-res-320-value="320"
              >
                <div class="tn-atom"></div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738522351701332885844"
                data-elem-id="1701332885844"
                data-elem-type="shape"
                data-field-top-value="451"
                data-field-left-value="439"
                data-field-height-value="229"
                data-field-width-value="359"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value="px"
                data-field-widthunits-value="px"
                data-field-top-res-320-value="411"
                data-field-left-res-320-value="0"
                data-field-height-res-320-value="176"
                data-field-width-res-320-value="320"
              >
                <div class="tn-atom"></div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738522351701332885846"
                data-elem-id="1701332885846"
                data-elem-type="shape"
                data-field-top-value="451"
                data-field-left-value="815"
                data-field-height-value="229"
                data-field-width-value="341"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value="px"
                data-field-widthunits-value="px"
                data-field-top-res-320-value="597"
                data-field-left-res-320-value="0"
                data-field-height-res-320-value="176"
                data-field-width-res-320-value="320"
              >
                <div class="tn-atom"></div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738522351470209944682"
                data-elem-id="1470209944682"
                data-elem-type="text"
                data-field-top-value="114"
                data-field-left-value="80"
                data-field-width-value="931"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="29"
                data-field-left-res-320-value="55"
                data-field-width-res-320-value="210"
              >
                <div class="tn-atom" field="tn_text_1470209944682">
                  Turn Chats Into Opportunities
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738522351701175709584"
                data-elem-id="1701175709584"
                data-elem-type="text"
                data-field-top-value="488"
                data-field-left-value="120"
                data-field-width-value="262"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="262"
                data-field-left-res-320-value="29"
              >
                <div class="tn-atom" field="tn_text_1701175709584">
                  <strong>Capture Leads</strong><br />Automatically collect
                  contact details of potential customers who show interest in your
                  products or services.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738522351701164464731"
                data-elem-id="1701164464731"
                data-elem-type="text"
                data-field-top-value="262"
                data-field-left-value="80"
                data-field-width-value="781"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="110"
                data-field-left-res-320-value="40"
                data-field-width-res-320-value="240"
              >
                <div class="tn-atom" field="tn_text_1701164464731">
                  Our chatbot does more than answer questions – it's a powerful
                  tool for growing your business.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738522351701175723418"
                data-elem-id="1701175723418"
                data-elem-type="text"
                data-field-top-value="488"
                data-field-left-value="498"
                data-field-width-value="240"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="448"
                data-field-left-res-320-value="29"
              >
                <div class="tn-atom" field="tn_text_1701175723418">
                  <strong>Qualify Prospects</strong><br />Identify high-potential
                  leads based on their interactions, saving you time and effort.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738522351701176417265"
                data-elem-id="1701176417265"
                data-elem-type="text"
                data-field-top-value="488"
                data-field-left-value="884"
                data-field-width-value="217"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="634"
                data-field-left-res-320-value="29"
              >
                <div class="tn-atom" field="tn_text_1701176417265">
                  <strong>Nurture Relationships</strong><br />Use the information
                  gathered to follow up effectively, turning inquiries into sales.
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738522351701333074526"
                data-elem-id="1701333074526"
                data-elem-type="image"
                data-field-top-value="700"
                data-field-left-value="320"
                data-field-width-value="154"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="376"
                data-field-fileheight-value="326"
                data-field-top-res-320-value="569"
                data-field-left-res-320-value="224"
                data-field-width-res-320-value="75"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild3239-3831-4332-b630-373135323134__star.png"
                    alt=""
                    imgfield="tn_img_1701333074526"
                  />
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738522351701332939537"
                data-elem-id="1701332939537"
                data-elem-type="image"
                data-field-top-value="382"
                data-field-left-value="1042"
                data-field-width-value="114"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="734"
                data-field-fileheight-value="521"
                data-field-top-res-320-value="384"
                data-field-left-res-320-value="205"
                data-field-width-res-320-value="77"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild3135-3431-4134-a634-393939306639__untitled-2.png"
                    alt=""
                    imgfield="tn_img_1701332939537"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- /T396 -->
        </div>
        <div
          id="rec673853286"
          class="r t-rec"
          style=""
          data-animationappear="off"
          data-record-type="396"
        >
          <!-- T396 -->
          <div class="t396">
            <div
              class="t396__artboard"
              data-artboard-recid="673853286"
              data-artboard-screens="320,480,640,960,1200"
              data-artboard-height="970"
              data-artboard-valign="center"
              data-artboard-upscale="grid"
              data-artboard-height-res-320="1530"
            >
              <div class="t396__carrier" data-artboard-recid="673853286"></div>
              <div class="t396__filter" data-artboard-recid="673853286"></div>
              <div
                class="t396__elem tn-elem tn-elem__6738532861701340968416"
                data-elem-id="1701340968416"
                data-elem-type="shape"
                data-field-top-value="331"
                data-field-left-value="20"
                data-field-height-value="549"
                data-field-width-value="362"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value="px"
                data-field-widthunits-value="px"
                data-field-top-res-320-value="154"
                data-field-left-res-320-value="0"
                data-field-height-res-320-value="382"
                data-field-width-res-320-value="321"
              >
                <div class="tn-atom"></div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738532861701340927203"
                data-elem-id="1701340927203"
                data-elem-type="shape"
                data-field-top-value="331"
                data-field-left-value="820"
                data-field-height-value="549"
                data-field-width-value="362"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value="px"
                data-field-widthunits-value="px"
                data-field-top-res-320-value="1015"
                data-field-left-res-320-value="0"
                data-field-height-res-320-value="470"
                data-field-width-res-320-value="320"
              >
                <div class="tn-atom"></div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738532861701340985837"
                data-elem-id="1701340985837"
                data-elem-type="shape"
                data-field-top-value="331"
                data-field-left-value="420"
                data-field-height-value="549"
                data-field-width-value="362"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value="px"
                data-field-widthunits-value="px"
                data-field-top-res-320-value="554"
                data-field-left-res-320-value="0"
                data-field-height-res-320-value="432"
                data-field-width-res-320-value="321"
              >
                <div class="tn-atom"></div>
              </div>
              <!-- <div
                class="t396__elem tn-elem tn-elem__6738532861701340977770"
                data-elem-id="1701340977770"
                data-elem-type="shape"
                data-field-top-value="914"
                data-field-left-value="20"
                data-field-height-value="512"
                data-field-width-value="760"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value="px"
                data-field-widthunits-value="px"
                data-field-top-res-320-value="1511"
                data-field-left-res-320-value="0"
                data-field-height-res-320-value="566"
                data-field-width-res-320-value="320"
              >
                <div class="tn-atom"></div>
              </div> -->
              <div
                class="t396__elem tn-elem tn-elem__6738532861470209944682"
                data-elem-id="1470209944682"
                data-elem-type="text"
                data-field-top-value="114"
                data-field-left-value="135"
                data-field-width-value="931"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="35"
                data-field-left-res-320-value="43"
                data-field-width-res-320-value="234"
              >
                <div class="tn-atom" field="tn_text_1470209944682">
                  Choose Your Plan
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738532861701164464731"
                data-elem-id="1701164464731"
                data-elem-type="text"
                data-field-top-value="211"
                data-field-left-value="345"
                data-field-width-value="510"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="77"
                data-field-left-res-320-value="37"
                data-field-width-res-320-value="246"
              >
                <div class="tn-atom" field="tn_text_1701164464731">
                  Simple, Transparent Pricing for Businesses of All Sizes
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738532861701340529940"
                data-elem-id="1701340529940"
                data-elem-type="text"
                data-field-top-value="346"
                data-field-left-value="60"
                data-field-width-value="115"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="169"
                data-field-left-res-320-value="103"
              >
                <div class="tn-atom" field="tn_text_1701340529940">Starter</div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738532861701340567255"
                data-elem-id="1701340567255"
                data-elem-type="text"
                data-field-top-value="539"
                data-field-left-value="60"
                data-field-width-value="279"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="263"
                data-field-left-res-320-value="48"
                data-field-width-res-320-value="224"
              >
                <div class="tn-atom" field="tn_text_1701340567255">
                  <ul class="some_class">
                    <li>1 chatbot</li>
                    <li>Upto 4k messages per month</li>
                    <li>Upto 200 training web pages</li>
                    <li>10 file uploads</li>
                    <li>Upto 10 MB per file</li>
                  </ul>
                </div>
              </div>
              <!-- <div
                class="t396__elem tn-elem tn-elem__6738532861701340718235"
                data-elem-id="1701340718235"
                data-elem-type="text"
                data-field-top-value="953"
                data-field-left-value="80"
                data-field-width-value="115"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="1533"
                data-field-left-res-320-value="103"
              >
                <div class="tn-atom" field="tn_text_1701340718235">
                  Enterprise
                </div>
              </div> -->
              <!-- <div
                class="t396__elem tn-elem tn-elem__6738532861701340824011"
                data-elem-id="1701340824011"
                data-elem-type="text"
                data-field-top-value="1133"
                data-field-left-value="80"
                data-field-width-value="330"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="1632"
                data-field-left-res-320-value="48"
                data-field-width-res-320-value="262"
              >
                <div class="tn-atom" field="tn_text_1701340824011">
                  <ul class="some_class">
                    <li>Unlimited chatbots</li>
                    <li>Unlimited messages per month</li>
                    <li>Upto 100,000 training web pages</li>
                    <li>1000 file uploads</li>
                    <li>Upto 10 MB per file</li>
                    <li>Unlimited integrations</li>
                  </ul>
                </div>
              </div> -->
              <!-- <div
                class="t396__elem tn-elem tn-elem__6738532861701340718237"
                data-elem-id="1701340718237"
                data-elem-type="text"
                data-field-top-value="1133"
                data-field-left-value="410"
                data-field-width-value="240"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="1781"
                data-field-left-res-320-value="48"
              >
                <div class="tn-atom" field="tn_text_1701340718237">
                  <ul class="some_class">
                    <li>Unlimited members</li>
                    <li>API Access</li>
                    <li>Webhook support</li>
                    <li>Use your own domain for embed scripts</li>
                    <li>Priority support</li>
                    <li>Custom Integrations</li>
                  </ul>
                </div>
              </div> -->
              <div
                class="t396__elem tn-elem tn-elem__6738532861701340605854"
                data-elem-id="1701340605854"
                data-elem-type="text"
                data-field-top-value="346"
                data-field-left-value="461"
                data-field-width-value="115"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="569"
                data-field-left-res-320-value="103"
              >
                <div class="tn-atom" field="tn_text_1701340605854">Growth</div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738532861701340605855"
                data-elem-id="1701340605855"
                data-elem-type="text"
                data-field-top-value="539"
                data-field-left-value="461"
                data-field-width-value="299"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="665"
                data-field-left-res-320-value="48"
                data-field-width-res-320-value="236"
              >
                <div class="tn-atom" field="tn_text_1701340605855">
                  <ul class="some_class">
                    <li>2 chatbot</li>
                    <li>Upto 40k messages per month</li>
                    <li>Upto 2,000 training web pages</li>
                    <li>100 file uploads</li>
                    <li>Upto 10 MB per file</li>
                  </ul>
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738532861701340674345"
                data-elem-id="1701340674345"
                data-elem-type="text"
                data-field-top-value="346"
                data-field-left-value="882"
                data-field-width-value="115"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="1030"
                data-field-left-res-320-value="103"
              >
                <div class="tn-atom" field="tn_text_1701340674345">Scale</div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738532861701340674347"
                data-elem-id="1701340674347"
                data-elem-type="text"
                data-field-top-value="539"
                data-field-left-value="882"
                data-field-width-value="299"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="1135"
                data-field-left-res-320-value="48"
                data-field-width-res-320-value="241"
              >
                <div class="tn-atom" field="tn_text_1701340674347">
                  <ul class="some_class">
                    <li>5 chatbot</li>
                    <li>Upto 40k messages per month</li>
                    <li>Upto 10,000 training web pages</li>
                    <li>500 file uploads</li>
                    <li>Upto 10 MB per file</li>
                  </ul>
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738532861701341099837"
                data-elem-id="1701341099837"
                data-elem-type="button"
                data-field-top-value="796"
                data-field-left-value="62"
                data-field-height-value="53"
                data-field-width-value="279"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value="px"
                data-field-widthunits-value="px"
                data-field-top-res-320-value="440"
                data-field-left-res-320-value="21"
              >
                <div @click="switchToLogin" class="tn-atom click_btn">Start Plan</div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738532861701341114021"
                data-elem-id="1701341114021"
                data-elem-type="button"
                data-field-top-value="796"
                data-field-left-value="462"
                data-field-height-value="53"
                data-field-width-value="279"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value="px"
                data-field-widthunits-value="px"
                data-field-top-res-320-value="898"
                data-field-left-res-320-value="21"
              >
                <div @click="switchToLogin" class="tn-atom click_btn">Start Plan</div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738532861701341132441"
                data-elem-id="1701341132441"
                data-elem-type="button"
                data-field-top-value="796"
                data-field-left-value="862"
                data-field-height-value="53"
                data-field-width-value="279"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value="px"
                data-field-widthunits-value="px"
                data-field-top-res-320-value="1394"
                data-field-left-res-320-value="21"
              >
                <div  @click="switchToLogin" class="tn-atom click_btn">Start Plan</div>
              </div>
              <!-- <div
                class="t396__elem tn-elem tn-elem__6738532861701341060764"
                data-elem-id="1701341060764"
                data-elem-type="button"
                data-field-top-value="1344"
                data-field-left-value="80"
                data-field-height-value="53"
                data-field-width-value="204"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value="px"
                data-field-widthunits-value="px"
                data-field-top-res-320-value="1989"
                data-field-left-res-320-value="58"
              >
                <div @click="switchToLogin" class="tn-atom click_btn">Contact us</div>
              </div> -->
              <!-- <div
                class="t396__elem tn-elem tn-elem__6738532861701515986900"
                data-elem-id="1701515986900"
                data-elem-type="image"
                data-field-top-value="128"
                data-field-left-value="200"
                data-field-width-value="128"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="213"
                data-field-fileheight-value="284"
                data-field-top-res-320-value="254"
                data-field-left-res-320-value="251"
                data-field-width-res-320-value="68"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild3664-6335-4536-b262-393034386638__stars.png"
                    alt=""
                    imgfield="tn_img_1701515986900"
                  />
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738532861701516018586"
                data-elem-id="1701516018586"
                data-elem-type="image"
                data-field-top-value="956"
                data-field-left-value="796"
                data-field-width-value="154"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-filewidth-value="213"
                data-field-fileheight-value="284"
                data-field-top-res-320-value="1283"
                data-field-left-res-320-value="232"
                data-field-width-res-320-value="71"
              >
                <div class="tn-atom">
                  <img
                    class="tn-atom__img t-img"
                    data-original="images/tild3664-6335-4536-b262-393034386638__stars.png"
                    alt=""
                    imgfield="tn_img_1701516018586"
                  />
                </div>
              </div> -->
              <div
                class="t396__elem tn-elem tn-elem__6738532861701175709584"
                data-elem-id="1701175709584"
                data-elem-type="text"
                data-field-top-value="400"
                data-field-left-value="60"
                data-field-width-value="163"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="200"
                data-field-left-res-320-value="43"
                data-field-width-res-320-value="105"
              >
                <div class="tn-atom" field="tn_text_1701175709584">
                  <strong>$49</strong>/mo
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738532861701340605851"
                data-elem-id="1701340605851"
                data-elem-type="text"
                data-field-top-value="400"
                data-field-left-value="461"
                data-field-width-value="163"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="602"
                data-field-left-res-320-value="46"
                data-field-width-res-320-value="99"
              >
                <div class="tn-atom" field="tn_text_1701340605851">
                  <strong>$99</strong>/mo
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738532861701605891839"
                data-elem-id="1701605891839"
                data-elem-type="text"
                data-field-top-value="474"
                data-field-left-value="60"
                data-field-width-value="241"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="200"
                data-field-left-res-320-value="148"
                data-field-width-res-320-value="129"
              >
                <div class="tn-atom" field="tn_text_1701605891839">
                  <!-- <strong>or $490</strong>/yr -->
                </div>
              </div>
              <!-- <div
                class="t396__elem tn-elem tn-elem__6738532861701605950265"
                data-elem-id="1701605950265"
                data-elem-type="text"
                data-field-top-value="474"
                data-field-left-value="461"
                data-field-width-value="241"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="602"
                data-field-left-res-320-value="146"
                data-field-width-res-320-value="128"
              >
                <div class="tn-atom" field="tn_text_1701605950265">
                  <strong>or $990</strong>/yr
                </div>
              </div> -->
              <div
                class="t396__elem tn-elem tn-elem__6738532861701340674343"
                data-elem-id="1701340674343"
                data-elem-type="text"
                data-field-top-value="400"
                data-field-left-value="882"
                data-field-width-value="163"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="1063"
                data-field-left-res-320-value="29"
                data-field-width-res-320-value="114"
              >
                <div class="tn-atom" field="tn_text_1701340674343">
                  <strong>$399</strong>/mo
                </div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6738532861701605967184"
                data-elem-id="1701605967184"
                data-elem-type="text"
                data-field-top-value="474"
                data-field-left-value="882"
                data-field-width-value="241"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="1063"
                data-field-left-res-320-value="144"
                data-field-width-res-320-value="146"
              >
                <div class="tn-atom" field="tn_text_1701605967184">
                  <!-- <strong>or $3990</strong>/yr -->
                </div>
              </div>
              <!-- <div
                class="t396__elem tn-elem tn-elem__6738532861701340718239"
                data-elem-id="1701340718239"
                data-elem-type="text"
                data-field-top-value="1007"
                data-field-left-value="80"
                data-field-width-value="163"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="1568"
                data-field-left-res-320-value="27"
                data-field-width-res-320-value="111"
              >
                <div class="tn-atom" field="tn_text_1701340718239">
                  <strong>$999</strong>/mo
                </div>
              </div> -->
              <!-- <div
                class="t396__elem tn-elem tn-elem__6738532861701605984771"
                data-elem-id="1701605984771"
                data-elem-type="text"
                data-field-top-value="1073"
                data-field-left-value="80"
                data-field-width-value="241"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="1568"
                data-field-left-res-320-value="138"
                data-field-width-res-320-value="148"
              >
                <div class="tn-atom" field="tn_text_1701605984771">
                  <strong>or $9990</strong>/yr
                </div>
              </div> -->
            </div>
          </div>
          <!-- /T396 -->
        </div>
        <div
          id="rec675753249"
          class="r t-rec t-rec_pb_0"
          style="padding-bottom: 0px"
          data-animationappear="off"
          data-record-type="396"
        >
          <!-- T396 -->
          <div class="t396">
            <div
              class="t396__artboard"
              data-artboard-recid="675753249"
              data-artboard-screens="320,480,640,960,1200"
              data-artboard-height="10"
              data-artboard-valign="center"
              data-artboard-upscale="grid"
            >
              <div class="t396__carrier" data-artboard-recid="675753249"></div>
              <div class="t396__filter" data-artboard-recid="675753249"></div>
            </div>
          </div>
          <!-- /T396 -->
        </div>
        <div
          id="rec674784807"
          class="r t-rec t-rec_pt_0"
          style="padding-top: 0px"
          data-animationappear="off"
          data-record-type="396"
        >
          <!-- T396 -->
          <div class="t396">
            <div
              class="t396__artboard"
              data-artboard-recid="674784807"
              data-artboard-screens="320,480,640,960,1200"
              data-artboard-height="250"
              data-artboard-valign="center"
              data-artboard-upscale="grid"
              data-artboard-height-res-320="110"
            >
              <div class="t396__carrier" data-artboard-recid="674784807"></div>
              <div class="t396__filter" data-artboard-recid="674784807"></div>
              <div
                class="t396__elem tn-elem tn-elem__6747848071470209944682"
                data-elem-id="1470209944682"
                data-elem-type="text"
                data-field-top-value="63"
                data-field-left-value="135"
                data-field-width-value="931"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="40"
                data-field-left-res-320-value="130"
                data-field-width-res-320-value="60"
              >
                <div class="tn-atom" field="tn_text_1470209944682">FAQ</div>
              </div>
              <div
                class="t396__elem tn-elem tn-elem__6747848071701164464731"
                data-elem-id="1701164464731"
                data-elem-type="text"
                data-field-top-value="178"
                data-field-left-value="320"
                data-field-width-value="561"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="86"
                data-field-left-res-320-value="23"
                data-field-width-res-320-value="275"
              >
                <div class="tn-atom" field="tn_text_1701164464731">
                  Chat bot training and support
                </div>
              </div>
            </div>
          </div>
          <!-- /T396 -->
        </div>
        <div
          id="rec673857212"
          class="r t-rec t-rec_pt_30 t-rec_pb_90"
          style="padding-top: 30px; padding-bottom: 90px"
          data-animationappear="off"
          data-record-type="585"
        >
          <!-- T585 -->
          <div class="t585">
            <div class="t-container">
              <!-- <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion1_673857212"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__8477175426420"
                          >Is there an API for SiteGPT?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              class="gpt_svg_plus"
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion1_673857212" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__8477175426420"
                        >
                          Yes, we offer a comprehensive API. Check our website or
                          contact us for more details.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion2_673857212"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__8477175426421"
                          >Which version of GPT does Replymonster use?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion2_673857212" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__8477175426421"
                        >
                          We use the GPT-4 API to ensure the best quality support
                          experience for our customers.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion3_673857212"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__8477175426422"
                          >How can I add the chatbot to my website?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion3_673857212" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__8477175426422"
                        >
                          Each chatbot has a unique URL and can be easily embedded
                          on your site with our provided code.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion4_673857212"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__1701333291030"
                          >Can I integrate SiteGPT with Facebook Messenger or
                          Slack?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion4_673857212" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__1701333291030"
                        >
                          Yes, we have integrations with Facebook Messenger and
                          Slack. Contact us, and we'll enable it for you.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
              <!-- <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion5_673857212"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__1701333303833"
                          >What about integration with other chat providers?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion5_673857212" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__1701333303833"
                        >
                          We currently integrate with Crisp, Zendesk, Messenger,
                          and Slack, and are open to building more custom
                          integrations.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion6_673857212"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__1701333315468"
                          >How does Replymonster handle message counting?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion6_673857212" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__1701333315468"
                        >
                          Both the user's message and the bot's reply are counted
                          as separate messages.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion7_673857212"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__1701333370503"
                          >Can the chatbot integrate with ticketing
                          platforms?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion7_673857212" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__1701333370503"
                        >
                          Yes, for Enterprise customers. If you need integration
                          with platforms like Zendesk or Hubspot, we'll create a
                          custom plan for you.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion8_673857212"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__1701333378442"
                          >Can I see the interactions my users have with the
                          chatbot?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion8_673857212" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__1701333378442"
                        >
                          Yes, you'll have complete access to all chat
                          interactions and, in the future, automated insights
                          based on these interactions.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion9_673857212"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__1701333391918"
                          >Can the chatbot be customized?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion9_673857212" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__1701333391918"
                        >
                          You can customize the chatbot's appearance, name, and
                          more to match your brand.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion10_673857212"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__1701335505415"
                          >Do you store chatbot messages?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion10_673857212" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__1701335505415"
                        >
                          Yes, we store the questions asked and the chatbot's
                          responses, accessible to the chatbot owner via the
                          dashboard.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion11_673857212"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__1701335519690"
                          >Does the chatbot support multiple languages?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion11_673857212" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__1701335519690"
                        >
                          Our chatbot can interact in various languages, suitable
                          for multilingual websites.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion12_673857212"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__1701335532593"
                          >Do you use OpenAI models?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion12_673857212" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__1701335532593"
                        >
                          Currently, all our chatbot solutions are powered by
                          OpenAI models.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion13_673857212"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__1701335546075"
                          >What if I need a feature not currently supported?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion13_673857212" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__1701335546075"
                        >
                          For custom features or integrations, join our Enterprise
                          plan for a solution tailored to your business needs.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="t585__border"
                  style="height: 1px; background-color: #eee"
                ></div>
              </div> -->
            </div>
          </div>
        </div>
        <div
          id="rec674787669"
          class="r t-rec"
          style=""
          data-animationappear="off"
          data-record-type="396"
        >
          <!-- T396 -->
          <div class="t396">
            <div
              class="t396__artboard"
              data-artboard-recid="674787669"
              data-artboard-screens="320,480,640,960,1200"
              data-artboard-height="130"
              data-artboard-valign="center"
              data-artboard-upscale="grid"
              data-artboard-height-res-320="30"
            >
              <div class="t396__carrier" data-artboard-recid="674787669"></div>
              <div class="t396__filter" data-artboard-recid="674787669"></div>
              <div
                class="t396__elem tn-elem tn-elem__6747876691701164464731"
                data-elem-id="1701164464731"
                data-elem-type="text"
                data-field-top-value="70"
                data-field-left-value="320"
                data-field-width-value="561"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="-3"
                data-field-left-res-320-value="-120"
              >
                <div class="tn-atom" field="tn_text_1701164464731">Pricing</div>
              </div>
            </div>
          </div>
          <!-- /T396 -->
        </div>
        <div
          id="rec674800383"
          class="r t-rec t-rec_pt_45 t-rec_pb_90"
          style="padding-top: 45px; padding-bottom: 90px"
          data-animationappear="off"
          data-record-type="585"
        >
          <!-- T585 -->
          <div class="t585">
            <div class="t-container">
              <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion1_674800383"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__7616747855300"
                          >Can I use one chatbot on multiple websites?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion1_674800383" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__7616747855300"
                        >
                          Definitely! You can add our chatbot to as many sites as
                          you like, making it versatile for all your visitor
                          interactions.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion2_674800383"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__7616747855301"
                          >Do you offer services for agencies?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion2_674800383" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__7616747855301"
                        >
                          Yes, we have special plans for agencies. For more
                          details, feel free to reach out via email.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion3_674800383"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__7616747855302"
                          >Is there a free plan available?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion3_674800383" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__7616747855302"
                        >
                          While we don't have a free plan, we offer a 14-day free
                          trial. You can also explore the capabilities of our
                          chatbot through our online demo.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion4_674800383"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__7616747855303"
                          >Are there limits on the number of messages?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion4_674800383" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__7616747855303"
                        >
                          Yes, different plans have different message limits. You
                          can check our pricing plans for details or purchase
                          add-ons for more capacity.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion5_674800383"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__7616747855304"
                          >Can the chatbot support non-English websites?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion5_674800383" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__7616747855304"
                        >
                          Absolutely! Our chatbot can interact in various
                          languages, making it perfect for global businesses.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion6_674800383"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__7616747855305"
                          >What if I need a custom integration or feature?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion6_674800383" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__7616747855305"
                        >
                          Join as an enterprise customer, and we'll tailor a
                          custom pricing plan to fit your specific needs.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion7_674800383"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__7616747855306"
                          >Is there a white label option available?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion7_674800383" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__7616747855306"
                        >
                          Interested in a whitelabel solution? Contact us to
                          discuss your needs and the associated pricing.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="t585__border"
                  style="height: 1px; background-color: #eee"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="rec674800315"
          class="r t-rec"
          style=""
          data-animationappear="off"
          data-record-type="396"
        >
          <!-- T396 -->
          <div class="t396">
            <div
              class="t396__artboard"
              data-artboard-recid="674800315"
              data-artboard-screens="320,480,640,960,1200"
              data-artboard-height="130"
              data-artboard-valign="center"
              data-artboard-upscale="grid"
              data-artboard-height-res-320="60"
            >
              <div class="t396__carrier" data-artboard-recid="674800315"></div>
              <div class="t396__filter" data-artboard-recid="674800315"></div>
              <div
                class="t396__elem tn-elem tn-elem__6748003151701164464731"
                data-elem-id="1701164464731"
                data-elem-type="text"
                data-field-top-value="70"
                data-field-left-value="320"
                data-field-width-value="561"
                data-field-axisy-value="top"
                data-field-axisx-value="left"
                data-field-container-value="grid"
                data-field-topunits-value="px"
                data-field-leftunits-value="px"
                data-field-heightunits-value=""
                data-field-widthunits-value="px"
                data-field-top-res-320-value="-3"
                data-field-left-res-320-value="54"
                data-field-width-res-320-value="212"
              >
                <div class="tn-atom" field="tn_text_1701164464731">
                  Technology and Integrations
                </div>
              </div>
            </div>
          </div>
          <!-- /T396 -->
        </div>
        <div
          id="rec674785530"
          class="r t-rec t-rec_pt_45 t-rec_pb_90"
          style="padding-top: 45px; padding-bottom: 90px"
          data-animationappear="off"
          data-record-type="585"
        >
          <!-- T585 -->
          <div class="t585">
            <div class="t-container">
              <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion1_674785530"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__7146738572120"
                          >Can I use text to train the chatbot if I don't have a
                          website or files?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion1_674785530" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__7146738572120"
                        >
                          Absolutely! You can enter any text content you have, and
                          our chatbot will learn from it to assist your customers.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion2_674785530"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__7146738572121"
                          >Do you offer services for agencies?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion2_674785530" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__7146738572121"
                        >
                          Yes, we do! Agencies can use our chatbots for their
                          clients. For more details, feel free to email us.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
              <!-- <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion3_674785530"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__7146738572122"
                          >Is there a way to see the chatbot in action before I
                          commit?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion3_674785530" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__7146738572122"
                        >
                          Of course! Visit our demo page to interact with a
                          chatbot trained on our own website. You can also enjoy a
                          14-day free trial to explore our features using your
                          data.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion4_674785530"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__7146738572123"
                          >What kinds of content can I use to train the
                          chatbot?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion4_674785530" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__7146738572123"
                        >
                          Our chatbot can learn from any content type, including
                          text, PDFs, CSVs, and more. The more content you
                          provide, the smarter it gets!
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion5_674785530"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__7146738572124"
                          >Will the chatbot update its knowledge
                          automatically?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion5_674785530" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__7146738572124"
                        >
                          Currently, you'll need to manually retrain your chatbot
                          using the dashboard. We're working on making this
                          process automatic for convenience.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion6_674785530"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__7146738572125"
                          >Can I upload large files for training the
                          chatbot?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion6_674785530" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__7146738572125"
                        >
                          Yes, you can upload various file types for training. If
                          your files are larger than 10 MB, please contact us for
                          assistance.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion7_674785530"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__7146738572126"
                          >How do I integrate the chatbot into my website?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion7_674785530" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__7146738572126"
                        >
                          It's easy! Each chatbot has a unique URL. We provide an
                          embed code that you can add to your site. You can also
                          link directly to the chatbot from your website.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion8_674785530"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__7146738572127"
                          >What's involved in training the chatbot?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion8_674785530" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__7146738572127"
                        >
                          Training is straightforward. Add a website link,
                          sitemap, or other links, and the chatbot will be trained
                          on that content. It usually takes just a few minutes.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="t-col t-col_8 t-prefix_2">
                <div
                  class="t585__accordion"
                  data-accordion="false"
                  data-scroll-to-expanded="false"
                >
                  <div class="t585__wrapper">
                    <div class="t585__header" style="border-top: 1px solid #eee">
                      <button
                        type="button"
                        class="t585__trigger-button"
                        aria-controls="accordion9_674785530"
                        aria-expanded="false"
                      >
                        <span
                          class="t585__title t-name t-name_xl"
                          field="li_title__7146738572128"
                          >How can I get in touch for more questions?</span
                        ><span class="t585__icon"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: transparent"
                          ></span></span
                        ><span class="t585__icon t585__icon-hover"
                          ><span class="t585__lines"
                            ><svg
                              role="presentation"
                              focusable="false"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <g
                                stroke="none"
                                stroke-width="1px"
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="square"
                              >
                                <g
                                  transform="translate(1.000000, 1.000000)"
                                  stroke="#222222"
                                >
                                  <path d="M0,11 L22,11"></path>
                                  <path d="M11,0 L11,22"></path>
                                </g>
                              </g></svg></span
                          ><span
                            class="t585__circle"
                            style="background-color: #eee"
                          ></span
                        ></span>
                      </button>
                    </div>
                    <div class="t585__content" id="accordion9_674785530" hidden>
                      <div class="t585__textwrapper">
                        <div
                          class="t585__text t-descr t-descr_xs"
                          field="li_descr__7146738572128"
                        >
                          For any further inquiries, reach us at
                          support@chatbot.ai. We're here to help!
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="t585__border"
                  style="height: 1px; background-color: #eee"
                ></div>
              </div> -->
            </div>
          </div>
        </div>
        <div
          id="rec673857777"
          class="r t-rec t-rec_pt_75 t-rec_pb_90"
          style="
            padding-top: 75px;
            padding-bottom: 90px;
            background-color: #111111;
          "
          data-animationappear="off"
          data-record-type="420"
          data-bg-color="#111111"
        >
          <!-- T420 -->
          <div class="t420">
            <div class="t-container t-align_left">
              <div class="t420__col t-col t-col_3">
                <a class="t420__logo-link" href="#"
                  ><img
                    class="t420__logo t-img"
                    src="images/logo_reply.svg"
                    data-original="images/logo_reply.svg"
                    imgfield="img"
                    alt="Product"
                /></a>
                <div class="t420__text t-descr t-descr_xxs" field="text">
                  © 4K-Soft Ltd. All rights reserved
                </div>
              </div>
              <div class="t420__col t-col t-col_3">
                <div
                  class="t420__title t-name t-name_xs t420__title_uppercase"
                  field="title"
                >
                  Product
                </div>
                <div class="t420__descr t-descr t-descr_xxs" field="descr">
                  <ul>
                    
                    <li><a href="#rec673853286">Tarifs</a></li>
                    <li> <a href="#rec674784807">FAQ</a></li>
                    <li><a href="#rec674787669">Pricing</a></li>
                    <li><a href="#rec674800315">Technology and Integrations</a></li>
                  </ul>
                </div>
              </div>
              <div class="t420__floatbeaker_lr3"></div>
              <div>
                <div class="t420__col t-col t-col_3">
                  <div
                    class="t420__title t-name t-name_xs t420__title_uppercase"
                    field="title2"
                  >
                    Legal
                  </div>
                  <div class="t420__descr t-descr t-descr_xxs" field="descr2">
                    <ul>
                      <li><a class="links_underline" target="_blank" href="https://playorium.com/chatgpt/tos">Terms &amp; Conditions</a></li>
                      <li><a class="links_underline" @click="openPrivacyPolicy">Privacy</a></li>
                      <li><a href="mailto:mail@support@replymonster.ai" class="links_underline">support@replymonster.ai</a></li>
                    </ul>
                  </div>
                </div>
                <div class="t420__col t-col t-col_3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import store from "../vuex/store";
  import Modal from "./Modal.vue";
  import Animation from "@/components/ChatBotDemo/Animation.vue";
  
  export default {
    data() {
      return {
        showModal: false,
        emailValue: "",
        emailValueTry: "",
        show_email: false,
        false_email: false
      };
    },
  
    components: { Modal, Animation },
  
    computed: {
      isLogged() {
        return (
          localStorage.getItem("token") && localStorage.getItem("refreshToken")
        );
      },
    },
  
    methods: {
      openPrivacyPolicy() {
        window.open('/policy', '_blank');
        },
      goToTryRegister(){
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (regex.test(this.emailValue)) {
            this.$emit("goToTryRegister", this.emailValue);
        } else {
          this.false_email = true
          setTimeout(() => {
              this.false_email = false;
              }, 2000);
        }
     
      },
      switchToLogin() {
        this.$emit("switchMode");
      },
      switchToReg() {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (regex.test(this.emailValueTry)) {
          this.$emit("switchModeValue", this.emailValueTry);
        } else {
          this.show_email = true
          setTimeout(() => {
              this.show_email = false;
              }, 2000);
        }
      },
      signUpAndOpenModal() {
        this.$emit("openModal");
        gtag('event', 'click_login', {});
        amplitude.getInstance().logEvent('click_login', {});
      },
      goToRoom() {
        store.dispatch("setLoggedIn", true);
        this.$router.push("/user");
      },
      handleClick(event) {
        if (event.target.classList.contains('widget_send_btn_img') || event.target.classList.contains('widget_send_btn')) {
          gtag('event', 'chatbot_message_sent', {});
          amplitude.getInstance().logEvent('chatbot_message_sent', {});
        }

        if (event.target.parentNode.classList.contains('widget_open_button')) {
          gtag('event', 'chatbot_main_widget_opened', {});
          amplitude.getInstance().logEvent('chatbot_main_widget_opened', {});
        }
      }
    },

    mounted() {
      this.handleButtonClick = this.handleClick.bind(this);
      document.addEventListener('click', this.handleButtonClick);
    },

    beforeCreate() {
      if (!document.querySelector('script[src="https://api.replymonster.ai/widget/widget.js"]')) {
        let script = document.createElement('script');
        script.src = 'https://api.replymonster.ai/widget/widget.js';
        script.async = true;
        script.setAttribute('token', 'U2FsdGVkX19gyb2nqTF3323kQM+VV6ODwfz8GkgbGNQuHU20tv7C6c9gJ2mDuiRi');
        document.body.appendChild(script);
      }
    },
    beforeDestroy() {
      let widgetApp = document.getElementById('widget_app');
      if (widgetApp) {
        widgetApp.style.display = 'none';
      }

      let script = document.querySelector('script[src="https://api.replymonster.ai/widget/widget.js"]');
      if (script) {
        script.parentNode.removeChild(script);
      }
      
      document.removeEventListener('click', this.handleButtonClick);
    }  
  
  };
  </script>
  <style>
  #rec674428398 .t-menu__link-item {
    -webkit-transition: color 0.3s ease-in-out, opacity 0.3s ease-in-out;
    transition: color 0.3s ease-in-out, opacity 0.3s ease-in-out;
  }
  #rec674428398 .t-menu__link-item.t-active:not(.t978__menu-link) {
    color: #7ed8ff !important;
  }
  @supports (overflow: -webkit-marquee) and (justify-content: inherit) {
    #rec674428398 .t-menu__link-item,
    #rec674428398 .t-menu__link-item.t-active {
      opacity: 1 !important;
    }
  }
  @media screen and (max-width: 980px) {
    #rec674428398 .t228__leftcontainer {
      padding: 20px;
    }
    #rec674428398 .t228__imglogo {
      padding: 20px 0;
    }
    #rec674428398 .t228 {
      position: static;
    }
  }
  .t-menuburger {
    position: relative;
    flex-shrink: 0;
    width: 28px;
    height: 20px;
    padding: 0;
    border: none;
    background-color: transparent;
    outline: none;
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    transition: transform 0.5s ease-in-out;
    cursor: pointer;
    z-index: 999;
  }
  /*---menu burger lines---*/
  .t-menuburger span {
    display: block;
    position: absolute;
    width: 100%;
    opacity: 1;
    left: 0;
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    transition: 0.25s ease-in-out;
    height: 3px;
    background-color: #000;
  }
  .t-menuburger span:nth-child(1) {
    top: 0px;
  }
  .t-menuburger span:nth-child(2),
  .t-menuburger span:nth-child(3) {
    top: 8px;
  }
  .t-menuburger span:nth-child(4) {
    top: 16px;
  }
  /*menu burger big*/
  .t-menuburger__big {
    width: 42px;
    height: 32px;
  }
  .t-menuburger__big span {
    height: 5px;
  }
  .t-menuburger__big span:nth-child(2),
  .t-menuburger__big span:nth-child(3) {
    top: 13px;
  }
  .t-menuburger__big span:nth-child(4) {
    top: 26px;
  }
  /*menu burger small*/
  .t-menuburger__small {
    width: 22px;
    height: 14px;
  }
  .t-menuburger__small span {
    height: 2px;
  }
  .t-menuburger__small span:nth-child(2),
  .t-menuburger__small span:nth-child(3) {
    top: 6px;
  }
  .t-menuburger__small span:nth-child(4) {
    top: 12px;
  }
  /*menu burger opened*/
  .t-menuburger-opened span:nth-child(1) {
    top: 8px;
    width: 0%;
    left: 50%;
  }
  .t-menuburger-opened span:nth-child(2) {
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  .t-menuburger-opened span:nth-child(3) {
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  .t-menuburger-opened span:nth-child(4) {
    top: 8px;
    width: 0%;
    left: 50%;
  }
  .t-menuburger-opened.t-menuburger__big span:nth-child(1) {
    top: 6px;
  }
  .t-menuburger-opened.t-menuburger__big span:nth-child(4) {
    top: 18px;
  }
  .t-menuburger-opened.t-menuburger__small span:nth-child(1),
  .t-menuburger-opened.t-menuburger__small span:nth-child(4) {
    top: 6px;
  }
  /*---menu burger first style---*/
  @media (hover), (min-width: 0\0) {
    .t-menuburger_first:hover span:nth-child(1) {
      transform: translateY(1px);
    }
    .t-menuburger_first:hover span:nth-child(4) {
      transform: translateY(-1px);
    }
    .t-menuburger_first.t-menuburger__big:hover span:nth-child(1) {
      transform: translateY(3px);
    }
    .t-menuburger_first.t-menuburger__big:hover span:nth-child(4) {
      transform: translateY(-3px);
    }
  }
  /*---menu burger second style---*/
  .t-menuburger_second span:nth-child(2),
  .t-menuburger_second span:nth-child(3) {
    width: 80%;
    left: 20%;
    right: 0;
  }
  @media (hover), (min-width: 0\0) {
    .t-menuburger_second.t-menuburger-hovered span:nth-child(2),
    .t-menuburger_second.t-menuburger-hovered span:nth-child(3) {
      animation: t-menuburger-anim 0.3s ease-out normal forwards;
    }
    .t-menuburger_second.t-menuburger-unhovered span:nth-child(2),
    .t-menuburger_second.t-menuburger-unhovered span:nth-child(3) {
      animation: t-menuburger-anim2 0.3s ease-out normal forwards;
    }
  }
  .t-menuburger_second.t-menuburger-opened span:nth-child(2),
  .t-menuburger_second.t-menuburger-opened span:nth-child(3) {
    left: 0;
    right: 0;
    width: 100% !important;
  }
  /*---menu burger third style---*/
  .t-menuburger_third span:nth-child(4) {
    width: 70%;
    left: unset;
    right: 0;
  }
  @media (hover), (min-width: 0\0) {
    .t-menuburger_third:not(.t-menuburger-opened):hover span:nth-child(4) {
      width: 100%;
    }
  }
  .t-menuburger_third.t-menuburger-opened span:nth-child(4) {
    width: 0 !important;
    right: 50%;
  }
  /*---menu burger fourth style---*/
  .t-menuburger_fourth {
    height: 12px;
  }
  .t-menuburger_fourth.t-menuburger__small {
    height: 8px;
  }
  .t-menuburger_fourth.t-menuburger__big {
    height: 18px;
  }
  .t-menuburger_fourth span:nth-child(2),
  .t-menuburger_fourth span:nth-child(3) {
    top: 4px;
    opacity: 0;
  }
  .t-menuburger_fourth span:nth-child(4) {
    top: 8px;
  }
  .t-menuburger_fourth.t-menuburger__small span:nth-child(2),
  .t-menuburger_fourth.t-menuburger__small span:nth-child(3) {
    top: 3px;
  }
  .t-menuburger_fourth.t-menuburger__small span:nth-child(4) {
    top: 6px;
  }
  .t-menuburger_fourth.t-menuburger__small span:nth-child(2),
  .t-menuburger_fourth.t-menuburger__small span:nth-child(3) {
    top: 3px;
  }
  .t-menuburger_fourth.t-menuburger__small span:nth-child(4) {
    top: 6px;
  }
  .t-menuburger_fourth.t-menuburger__big span:nth-child(2),
  .t-menuburger_fourth.t-menuburger__big span:nth-child(3) {
    top: 6px;
  }
  .t-menuburger_fourth.t-menuburger__big span:nth-child(4) {
    top: 12px;
  }
  @media (hover), (min-width: 0\0) {
    .t-menuburger_fourth:not(.t-menuburger-opened):hover span:nth-child(1) {
      transform: translateY(1px);
    }
    .t-menuburger_fourth:not(.t-menuburger-opened):hover span:nth-child(4) {
      transform: translateY(-1px);
    }
    .t-menuburger_fourth.t-menuburger__big:not(.t-menuburger-opened):hover
      span:nth-child(1) {
      transform: translateY(3px);
    }
    .t-menuburger_fourth.t-menuburger__big:not(.t-menuburger-opened):hover
      span:nth-child(4) {
      transform: translateY(-3px);
    }
  }
  .t-menuburger_fourth.t-menuburger-opened span:nth-child(1),
  .t-menuburger_fourth.t-menuburger-opened span:nth-child(4) {
    top: 4px;
  }
  .t-menuburger_fourth.t-menuburger-opened span:nth-child(2),
  .t-menuburger_fourth.t-menuburger-opened span:nth-child(3) {
    opacity: 1;
  }
  /*---menu burger animations---*/
  @keyframes t-menuburger-anim {
    0% {
      width: 80%;
      left: 20%;
      right: 0;
    }
    50% {
      width: 100%;
      left: 0;
      right: 0;
    }
    100% {
      width: 80%;
      left: 0;
      right: 20%;
    }
  }
  @keyframes t-menuburger-anim2 {
    0% {
      width: 80%;
      left: 0;
    }
    50% {
      width: 100%;
      right: 0;
      left: 0;
    }
    100% {
      width: 80%;
      left: 20%;
      right: 0;
    }
  }
  @media screen and (max-width: 980px) {
    #rec676200207 .t280__main_opened .t280__menu__content {
      background-color: #ffffff !important;
      opacity: 1 !important;
    }
  }
  #rec676200207 .t-menu__link-item {
  }
  @supports (overflow: -webkit-marquee) and (justify-content: inherit) {
    #rec676200207 .t-menu__link-item,
    #rec676200207 .t-menu__link-item.t-active {
      opacity: 1 !important;
    }
  }
  #rec673677530 .t396__artboard {
    min-height: 730px;
    height: 100vh;
    background-color: #ffffff;
    overflow: visible;
  }
  #rec673677530 .t396__filter {
    min-height: 730px;
    height: 100vh;
  }
  #rec673677530 .t396__carrier {
    min-height: 730px;
    height: 100vh;
    background-position: center center;
    background-attachment: scroll;
    background-size: cover;
    background-repeat: no-repeat;
  }
  
  @media screen and (max-width: 1199px) {
    #rec673677530 .t396__artboard {
    }
    #rec673677530 .t396__filter {
    }
    #rec673677530 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 959px) {
    #rec673677530 .t396__artboard {
    }
    #rec673677530 .t396__filter {
    }
    #rec673677530 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 639px) {
    #rec673677530 .t396__artboard {
    }
    #rec673677530 .t396__filter {
    }
    #rec673677530 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 479px) {
    #rec673677530 .t396__artboard {
      height: auto;
      height: inherit;
      height: 1080px;
      min-height: 1080px;
    }
    #rec673677530 .t396__filter {
      height: auto;
      height: inherit;
      height: 1080px;
      min-height: 1080px;
    }
    #rec673677530 .t396__carrier {
      height: auto;
      height: inherit;
      height: 1080px;
      min-height: 1080px;
      background-attachment: scroll;
    }
  }
  #rec673677530 .tn-elem[data-elem-id="1701622474544"] {
    z-index: 2;
    top: calc(50vh - 286.5px + 12px);
    left: calc(50% - 133.5px + 309px);
    width: 267px;
    height: 573px;
  }
  #rec673677530 .tn-elem[data-elem-id="1701622474544"] .tn-atom {
    background-color: #fff705;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673677530 .tn-elem[data-elem-id="1701622474544"] {
      top: 486.5px;
      left: calc(50% - 133.5px + 1px);
      width: 252px;
      height: 563px;
    }
  }
  #rec673677530 .tn-elem[data-elem-id="1470209944682"] {
    color: #000000;
    text-align: center;
    z-index: 3;
    top: calc(50vh - 0px + -288px);
    left: calc(50% - 370px + -234px);
    width: 740px;
  }
  #rec673677530 .tn-elem[data-elem-id="1470209944682"] .tn-atom {
    color: #000000;
    font-size: 60px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673677530 .tn-elem[data-elem-id="1470209944682"] {
      top: 93px !important;
      left: 50% !important;
    transform: translate(-50%, -50%) !important;
      width: 306px;
    }
    #rec673677530 .tn-elem[data-elem-id="1470209944682"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec673677530 .tn-elem[data-elem-id="1470210011265"] {
    color: #000000;
    text-align: center;
    z-index: 4;
    top: calc(50vh - 0px + -12px);
    left: calc(50% - 329.5px + -233px);
    width: 659px;
  }
  #rec673677530 .tn-elem[data-elem-id="1470210011265"] .tn-atom {
    color: #000000;
    font-size: 25px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 39px;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673677530 .tn-elem[data-elem-id="1470210011265"] {
      top: 230px !important;
      left: 50% !important;
    transform: translate(-50%, -50%) !important;
      width: 268px;
    }
    #rec673677530 .tn-elem[data-elem-id="1470210011265"] .tn-atom {
      font-size: 16px;
      line-height: 25px;
    }
  }
  #rec673677530 .tn-elem[data-elem-id="1701606787792"] {
    z-index: 5;
    top: calc(50vh - 0px + 217px);
    left: calc(50% - 263px + -234px);
    width: 526px;
  }
  #rec673677530 .tn-elem[data-elem-id="1701606787792"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673677530 .tn-elem[data-elem-id="1701606787792"] {
      top: 380px !important;
      left: 50% !important;
    transform: translate(-50%, -50%) !important;
      width: 302px;
    }
  }
  #rec673677530 .tn-elem[data-elem-id="1701610209969"] {
    color: #ababab;
    text-align: center;
    z-index: 6;
    top: calc(50vh - 0px + 277px);
    left: calc(50% - 276px + -234px);
    width: 552px;
  }
  #rec673677530 .tn-elem[data-elem-id="1701610209969"] .tn-atom {
    color: #ababab;
    font-size: 14px;
    font-family: "Arial", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673677530 .tn-elem[data-elem-id="1701610209969"] {
      top: 410.5px;
      left: 50%;
    transform: translate(-50%, -50%);
      width: 221px;
    }
    #rec673677530 .tn-elem[data-elem-id="1701610209969"] .tn-atom {
      font-size: 12px;
    }
  }
  .video_zero_block {
    overflow: hidden; /*Сотрите это свойство, если у вас включен автоскейл*/
  }
  .video_zero_block .tn-atom {
    background-image: none !important;
    background-color: transparent !important;
  }
  .video_zero_block video {
    object-fit: cover;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 10px; /*Радиус скругления углов у видео*/
  }
  #rec675752982 .t396__artboard {
    height: 10px;
    background-color: #8a76ff;
  }
  #rec675752982 .t396__filter {
    height: 10px;
  }
  #rec675752982 .t396__carrier {
    height: 10px;
    background-position: center center;
    background-attachment: scroll;
    background-size: cover;
    background-repeat: no-repeat;
  }
  @media screen and (max-width: 1199px) {
    #rec675752982 .t396__artboard {
    }
    #rec675752982 .t396__filter {
    }
    #rec675752982 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 959px) {
    #rec675752982 .t396__artboard {
    }
    #rec675752982 .t396__filter {
    }
    #rec675752982 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 639px) {
    #rec675752982 .t396__artboard {
    }
    #rec675752982 .t396__filter {
    }
    #rec675752982 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 479px) {
    #rec675752982 .t396__artboard {
    }
    #rec675752982 .t396__filter {
    }
    #rec675752982 .t396__carrier {
      background-attachment: scroll;
    }
  }
  #rec673703494 .t396__artboard {
    height: 1360px;
    background-color: #ffffff;
  }
  #rec673703494 .t396__filter {
    height: 1360px;
  }
  #rec673703494 .t396__carrier {
    height: 1360px;
    background-position: center center;
    background-attachment: scroll;
    background-size: cover;
    background-repeat: no-repeat;
  }
  @media screen and (max-width: 1199px) {
    #rec673703494 .t396__artboard {
    }
    #rec673703494 .t396__filter {
    }
    #rec673703494 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 959px) {
    #rec673703494 .t396__artboard {
    }
    #rec673703494 .t396__filter {
    }
    #rec673703494 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 639px) {
    #rec673703494 .t396__artboard {
    }
    #rec673703494 .t396__filter {
    }
    #rec673703494 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 479px) {
    #rec673703494 .t396__artboard {
      height: 1660px;
    }
    #rec673703494 .t396__filter {
      height: 1660px;
    }
    #rec673703494 .t396__carrier {
      height: 1660px;
      background-attachment: scroll;
    }
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519136"] {
    color: #000000;
    text-align: center;
    z-index: 2;
    top: 106px;
    left: calc(50% - 600px + 200px);
    width: 800px;
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519136"] .tn-atom {
    color: #000000;
    font-size: 60px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673703494 .tn-elem[data-elem-id="1701282519136"] {
      top: 40px;
      left: calc(50% - 160px + 27px);
      width: 267px;
    }
    #rec673703494 .tn-elem[data-elem-id="1701282519136"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519137"] {
    z-index: 3;
    top: 462px;
    left: calc(50% - 600px + 80px);
    width: 341px;
    height: 229px;
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519137"] .tn-atom {
    border-radius: 50px;
    background-color: #e9edf5;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673703494 .tn-elem[data-elem-id="1701282519137"] {
      top: 339px;
      left: calc(50% - 160px + 0px);
      width: 320px;
      height: 171px;
    }
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519140"] {
    z-index: 4;
    top: 462px;
    left: calc(50% - 600px + 439px);
    width: 359px;
    height: 229px;
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519140"] .tn-atom {
    border-radius: 50px;
    background-color: #f3f3f3;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673703494 .tn-elem[data-elem-id="1701282519140"] {
      top: 549px;
      left: calc(50% - 160px + 0px);
      width: 320px;
      height: 184px;
    }
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519143"] {
    z-index: 5;
    top: 462px;
    left: calc(50% - 600px + 815px);
    width: 341px;
    height: 229px;
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519143"] .tn-atom {
    border-radius: 50px;
    background-color: #e9edf5;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673703494 .tn-elem[data-elem-id="1701282519143"] {
      top: 856px;
      left: calc(50% - 160px + 0px);
      width: 320px;
      height: 146px;
    }
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519146"] {
    color: #000000;
    text-align: center;
    z-index: 6;
    top: 266px;
    left: calc(50% - 600px + 314px);
    width: 573px;
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519146"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673703494 .tn-elem[data-elem-id="1701282519146"] {
      top: 150px;
      left: calc(50% - 160px + 34px);
      width: 252px;
    }
    #rec673703494 .tn-elem[data-elem-id="1701282519146"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519147"] {
    color: #000000;
    z-index: 7;
    top: 499px;
    left: calc(50% - 600px + 136px);
    width: 244px;
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519147"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673703494 .tn-elem[data-elem-id="1701282519147"] {
      top: 376px;
      left: calc(50% - 160px + 44px);
    }
    #rec673703494 .tn-elem[data-elem-id="1701282519147"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519149"] {
    color: #000000;
    z-index: 8;
    top: 913px;
    left: calc(50% - 600px + 80px);
    width: 206px;
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519149"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673703494 .tn-elem[data-elem-id="1701282519149"] {
      top: 1126px;
      left: calc(50% - 160px + 32px);
      width: 256px;
    }
    #rec673703494 .tn-elem[data-elem-id="1701282519149"] {
      text-align: center;
    }
    #rec673703494 .tn-elem[data-elem-id="1701282519149"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519150"] {
    color: #000000;
    z-index: 9;
    top: 499px;
    left: calc(50% - 600px + 487px);
    width: 272px;
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519150"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673703494 .tn-elem[data-elem-id="1701282519150"] {
      top: 622px;
      left: calc(50% - 160px + 48px);
      width: 250px;
    }
    #rec673703494 .tn-elem[data-elem-id="1701282519150"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519151"] {
    color: #000000;
    z-index: 10;
    top: 913px;
    left: calc(50% - 600px + 406px);
    width: 248px;
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519151"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673703494 .tn-elem[data-elem-id="1701282519151"] {
      top: 1233px;
      left: calc(50% - 160px + 55px);
      width: 210px;
    }
    #rec673703494 .tn-elem[data-elem-id="1701282519151"] {
      text-align: center;
    }
    #rec673703494 .tn-elem[data-elem-id="1701282519151"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519153"] {
    color: #000000;
    z-index: 11;
    top: 499px;
    left: calc(50% - 600px + 869px);
    width: 272px;
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519153"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673703494 .tn-elem[data-elem-id="1701282519153"] {
      top: 893px;
      left: calc(50% - 160px + 54px);
      width: 231px;
    }
    #rec673703494 .tn-elem[data-elem-id="1701282519153"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519154"] {
    color: #000000;
    z-index: 12;
    top: 913px;
    left: calc(50% - 600px + 774px);
    width: 272px;
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519154"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673703494 .tn-elem[data-elem-id="1701282519154"] {
      top: 1368px;
      left: calc(50% - 160px + 58px);
      width: 204px;
    }
    #rec673703494 .tn-elem[data-elem-id="1701282519154"] {
      text-align: center;
    }
    #rec673703494 .tn-elem[data-elem-id="1701282519154"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519155"] {
    color: #000000;
    z-index: 13;
    top: 823px;
    left: calc(50% - 600px + 80px);
    width: 410px;
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519155"] .tn-atom {
    color: #000000;
    font-size: 41px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673703494 .tn-elem[data-elem-id="1701282519155"] {
      top: 1053px;
      left: calc(50% - 160px + 61px);
      width: 198px;
    }
    #rec673703494 .tn-elem[data-elem-id="1701282519155"] {
      text-align: center;
    }
    #rec673703494 .tn-elem[data-elem-id="1701282519155"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519157"] {
    color: #006eff;
    z-index: 14;
    top: 1124px;
    left: calc(50% - 600px + 80px);
    width: 850px;
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519157"] .tn-atom {
    color: #006eff;
    font-size: 42px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.1;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673703494 .tn-elem[data-elem-id="1701282519157"] {
      top: 1528px;
      left: calc(50% - 160px + 10px);
      width: 301px;
    }
    #rec673703494 .tn-elem[data-elem-id="1701282519157"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519158"] {
    z-index: 15;
    top: 400px;
    left: calc(50% - 600px + 168px);
    width: 187px;
    height: 73.241666666667px;
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519158"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519158"] .tn-atom {
    -webkit-transform: rotate(343deg);
    -moz-transform: rotate(343deg);
    transform: rotate(343deg);
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673703494 .tn-elem[data-elem-id="1701282519158"] {
      top: 295px;
      left: calc(50% - 160px + 90px);
      width: 141px;
      height: 55.225px;
    }
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519162"] {
    z-index: 16;
    top: 367px;
    left: calc(50% - 600px + 565px);
    width: 94px;
    height: 110.71111111111px;
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519162"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519162"] .tn-atom {
    -webkit-transform: rotate(343deg);
    -moz-transform: rotate(343deg);
    transform: rotate(343deg);
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673703494 .tn-elem[data-elem-id="1701282519162"] {
      top: 531px;
      left: calc(50% - 160px + 125px);
      width: 70px;
      height: 82.444444444444px;
    }
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519164"] {
    z-index: 17;
    top: 374px;
    left: calc(50% - 600px + 920px);
    width: 146px;
    height: 109.03927068724px;
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519164"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  #rec673703494 .tn-elem[data-elem-id="1701282519164"] .tn-atom {
    -webkit-transform: rotate(18deg);
    -moz-transform: rotate(18deg);
    transform: rotate(18deg);
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673703494 .tn-elem[data-elem-id="1701282519164"] {
      top: 801px;
      left: calc(50% - 160px + 110px);
      width: 100px;
      height: 74.68443197756px;
    }
  }
  #rec675753165 .t396__artboard {
    height: 10px;
    background-color: #8a76ff;
  }
  #rec675753165 .t396__filter {
    height: 10px;
  }
  #rec675753165 .t396__carrier {
    height: 10px;
    background-position: center center;
    background-attachment: scroll;
    background-size: cover;
    background-repeat: no-repeat;
  }
  @media screen and (max-width: 1199px) {
    #rec675753165 .t396__artboard {
    }
    #rec675753165 .t396__filter {
    }
    #rec675753165 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 959px) {
    #rec675753165 .t396__artboard {
    }
    #rec675753165 .t396__filter {
    }
    #rec675753165 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 639px) {
    #rec675753165 .t396__artboard {
    }
    #rec675753165 .t396__filter {
    }
    #rec675753165 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 479px) {
    #rec675753165 .t396__artboard {
    }
    #rec675753165 .t396__filter {
    }
    #rec675753165 .t396__carrier {
      background-attachment: scroll;
    }
  }
  #rec673837976 .t396__artboard {
    height: 1060px;
    background-color: #ffffff;
  }
  #rec673837976 .t396__filter {
    height: 1060px;
  }
  #rec673837976 .t396__carrier {
    height: 1060px;
    background-position: center center;
    background-attachment: scroll;
    background-size: cover;
    background-repeat: no-repeat;
  }
  @media screen and (max-width: 1199px) {
    #rec673837976 .t396__artboard {
    }
    #rec673837976 .t396__filter {
    }
    #rec673837976 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 959px) {
    #rec673837976 .t396__artboard {
    }
    #rec673837976 .t396__filter {
    }
    #rec673837976 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 639px) {
    #rec673837976 .t396__artboard {
    }
    #rec673837976 .t396__filter {
    }
    #rec673837976 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 479px) {
    #rec673837976 .t396__artboard {
      height: 1350px;
    }
    #rec673837976 .t396__filter {
      height: 1350px;
    }
    #rec673837976 .t396__carrier {
      height: 1350px;
      background-attachment: scroll;
    }
  }
  #rec673837976 .tn-elem[data-elem-id="1701287493889"] {
    color: #000000;
    z-index: 2;
    top: 105px;
    left: calc(50% - 600px + 80px);
    width: 1021px;
  }
  #rec673837976 .tn-elem[data-elem-id="1701287493889"] .tn-atom {
    color: #000000;
    font-size: 70px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673837976 .tn-elem[data-elem-id="1701287493889"] {
      top: 37px;
      left: calc(50% - 160px + 68px);
      width: 184px;
    }
    #rec673837976 .tn-elem[data-elem-id="1701287493889"] {
      text-align: center;
    }
    #rec673837976 .tn-elem[data-elem-id="1701287493889"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec673837976 .tn-elem[data-elem-id="1701287493905"] {
    color: #2b00ff;
    z-index: 3;
    top: 209px;
    left: calc(50% - 600px + 80px);
    width: 433px;
  }
  #rec673837976 .tn-elem[data-elem-id="1701287493905"] .tn-atom {
    color: #2b00ff;
    font-size: 41px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.1;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
  }
  #rec673837976 .tn-elem[data-elem-id="1701287493903"] {
    color: #000000;
    z-index: 4;
    top: 785px;
    left: calc(50% - 600px + 80px);
    width: 334px;
  }
  #rec673837976 .tn-elem[data-elem-id="1701287493903"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673837976 .tn-elem[data-elem-id="1701287493903"] {
      top: 924px;
      left: calc(50% - 160px + 10px);
      width: 301px;
    }
    #rec673837976 .tn-elem[data-elem-id="1701287493903"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673837976 .tn-elem[data-elem-id="1701287493906"] {
    color: #000000;
    z-index: 5;
    top: 402px;
    left: calc(50% - 600px + 479px);
    width: 305px;
  }
  #rec673837976 .tn-elem[data-elem-id="1701287493906"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673837976 .tn-elem[data-elem-id="1701287493906"] {
      top: 461px;
      left: calc(50% - 160px + 9px);
    }
    #rec673837976 .tn-elem[data-elem-id="1701287493906"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673837976 .tn-elem[data-elem-id="1701287493907"] {
    color: #000000;
    z-index: 6;
    top: 782px;
    left: calc(50% - 600px + 479px);
    width: 333px;
  }
  #rec673837976 .tn-elem[data-elem-id="1701287493907"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673837976 .tn-elem[data-elem-id="1701287493907"] {
      top: 1170px;
      left: calc(50% - 160px + 10px);
      width: 301px;
    }
    #rec673837976 .tn-elem[data-elem-id="1701287493907"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673837976 .tn-elem[data-elem-id="1701287493908"] {
    color: #000000;
    z-index: 7;
    top: 399px;
    left: calc(50% - 600px + 862px);
    width: 318px;
  }
  #rec673837976 .tn-elem[data-elem-id="1701287493908"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673837976 .tn-elem[data-elem-id="1701287493908"] {
      top: 701px;
      left: calc(50% - 160px + 9px);
      width: 303px;
    }
    #rec673837976 .tn-elem[data-elem-id="1701287493908"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673837976 .tn-elem[data-elem-id="1701287493910"] {
    z-index: 8;
    top: 316px;
    left: calc(50% - 600px + 598px);
    width: 67px;
    height: 69.951060358891px;
  }
  #rec673837976 .tn-elem[data-elem-id="1701287493910"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673837976 .tn-elem[data-elem-id="1701287493910"] {
      top: 400px;
      left: calc(50% - 160px + 140px);
      width: 42px;
      height: 43.849918433931px;
    }
  }
  #rec673837976 .tn-elem[data-elem-id="1701328860259"] {
    z-index: 9;
    top: 699px;
    left: calc(50% - 600px + 214px);
    width: 67px;
    height: 70.295081967213px;
  }
  #rec673837976 .tn-elem[data-elem-id="1701328860259"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673837976 .tn-elem[data-elem-id="1701328860259"] {
      top: 863px;
      left: calc(50% - 160px + 144px);
      width: 42px;
      height: 44.065573770492px;
    }
  }
  #rec673837976 .tn-elem[data-elem-id="1701287493890"] {
    color: #000000;
    z-index: 10;
    top: 394px;
    left: calc(50% - 600px + 80px);
    width: 321px;
  }
  #rec673837976 .tn-elem[data-elem-id="1701287493890"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673837976 .tn-elem[data-elem-id="1701287493890"] {
      top: 215px;
      left: calc(50% - 160px + 11px);
      width: 301px;
    }
    #rec673837976 .tn-elem[data-elem-id="1701287493890"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673837976 .tn-elem[data-elem-id="1701329241888"] {
    z-index: 11;
    top: 699px;
    left: calc(50% - 600px + 612px);
    width: 67px;
    height: 67px;
  }
  #rec673837976 .tn-elem[data-elem-id="1701329241888"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673837976 .tn-elem[data-elem-id="1701329241888"] {
      top: 1108px;
      left: calc(50% - 160px + 143px);
      width: 42px;
      height: 42px;
    }
  }
  #rec673837976 .tn-elem[data-elem-id="1701329249122"] {
    z-index: 12;
    top: 316px;
    left: calc(50% - 600px + 988px);
    width: 67px;
    height: 67px;
  }
  #rec673837976 .tn-elem[data-elem-id="1701329249122"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673837976 .tn-elem[data-elem-id="1701329249122"] {
      top: 644px;
      left: calc(50% - 160px + 147px);
      width: 42px;
      height: 42px;
    }
  }
  #rec673837976 .tn-elem[data-elem-id="1701328900415"] {
    z-index: 13;
    top: 316px;
    left: calc(50% - 600px + 207px);
    width: 67px;
    height: 62.184375px;
  }
  #rec673837976 .tn-elem[data-elem-id="1701328900415"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673837976 .tn-elem[data-elem-id="1701328900415"] {
      top: 161px;
      left: calc(50% - 160px + 140px);
      width: 42px;
      height: 38.98125px;
    }
  }
  #rec675753174 .t396__artboard {
    height: 10px;
    background-color: #8a76ff;
  }
  #rec675753174 .t396__filter {
    height: 10px;
  }
  #rec675753174 .t396__carrier {
    height: 10px;
    background-position: center center;
    background-attachment: scroll;
    background-size: cover;
    background-repeat: no-repeat;
  }
  @media screen and (max-width: 1199px) {
    #rec675753174 .t396__artboard {
    }
    #rec675753174 .t396__filter {
    }
    #rec675753174 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 959px) {
    #rec675753174 .t396__artboard {
    }
    #rec675753174 .t396__filter {
    }
    #rec675753174 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 639px) {
    #rec675753174 .t396__artboard {
    }
    #rec675753174 .t396__filter {
    }
    #rec675753174 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 479px) {
    #rec675753174 .t396__artboard {
    }
    #rec675753174 .t396__filter {
    }
    #rec675753174 .t396__carrier {
      background-attachment: scroll;
    }
  }
  #rec673845808 .t396__artboard {
    height: 980px;
    background-color: #ffffff;
  }
  #rec673845808 .t396__filter {
    height: 980px;
  }
  #rec673845808 .t396__carrier {
    height: 980px;
    background-position: center center;
    background-attachment: scroll;
    background-size: cover;
    background-repeat: no-repeat;
  }
  @media screen and (max-width: 1199px) {
    #rec673845808 .t396__artboard {
    }
    #rec673845808 .t396__filter {
    }
    #rec673845808 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 959px) {
    #rec673845808 .t396__artboard {
    }
    #rec673845808 .t396__filter {
    }
    #rec673845808 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 639px) {
    #rec673845808 .t396__artboard {
    }
    #rec673845808 .t396__filter {
    }
    #rec673845808 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 479px) {
    #rec673845808 .t396__artboard {
      height: 1450px;
    }
    #rec673845808 .t396__filter {
      height: 1450px;
    }
    #rec673845808 .t396__carrier {
      height: 1450px;
      background-attachment: scroll;
    }
  }
  #rec673845808 .tn-elem[data-elem-id="1470209944682"] {
    color: #000000;
    z-index: 2;
    top: 85px;
    left: calc(50% - 600px + 80px);
    width: 800px;
  }
  #rec673845808 .tn-elem[data-elem-id="1470209944682"] .tn-atom {
    color: #000000;
    font-size: 70px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673845808 .tn-elem[data-elem-id="1470209944682"] {
      top: 33px;
      left: calc(50% - 160px + 11px);
      width: 300px;
    }
    #rec673845808 .tn-elem[data-elem-id="1470209944682"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec673845808 .tn-elem[data-elem-id="1701175709584"] {
    color: #000000;
    z-index: 3;
    top: 632px;
    left: calc(50% - 600px + 80px);
    width: 317px;
  }
  #rec673845808 .tn-elem[data-elem-id="1701175709584"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673845808 .tn-elem[data-elem-id="1701175709584"] {
      top: 395px;
      left: calc(50% - 160px + 10px);
      width: 302px;
    }
    #rec673845808 .tn-elem[data-elem-id="1701175709584"] {
      text-align: center;
    }
    #rec673845808 .tn-elem[data-elem-id="1701175709584"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673845808 .tn-elem[data-elem-id="1701175723418"] {
    color: #000000;
    z-index: 4;
    top: 632px;
    left: calc(50% - 600px + 460px);
    width: 325px;
  }
  #rec673845808 .tn-elem[data-elem-id="1701175723418"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673845808 .tn-elem[data-elem-id="1701175723418"] {
      top: 832px;
      left: calc(50% - 160px + 10px);
      width: 301px;
    }
    #rec673845808 .tn-elem[data-elem-id="1701175723418"] {
      text-align: center;
    }
    #rec673845808 .tn-elem[data-elem-id="1701175723418"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673845808 .tn-elem[data-elem-id="1701329430713"] {
    color: #006eff;
    z-index: 5;
    top: 550px;
    left: calc(50% - 600px + 80px);
    width: 111px;
  }
  #rec673845808 .tn-elem[data-elem-id="1701329430713"] .tn-atom {
    color: #006eff;
    font-size: 41px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.1;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673845808 .tn-elem[data-elem-id="1701329430713"] {
      top: 346px;
      left: calc(50% - 160px + 105px);
    }
    #rec673845808 .tn-elem[data-elem-id="1701329430713"] {
      text-align: center;
    }
    #rec673845808 .tn-elem[data-elem-id="1701329430713"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec673845808 .tn-elem[data-elem-id="1701164471399"] {
    color: #000000;
    z-index: 6;
    top: 632px;
    left: calc(50% - 600px + 843px);
    width: 279px;
  }
  #rec673845808 .tn-elem[data-elem-id="1701164471399"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673845808 .tn-elem[data-elem-id="1701164471399"] {
      top: 1287px;
      left: calc(50% - 160px + 21px);
    }
    #rec673845808 .tn-elem[data-elem-id="1701164471399"] {
      text-align: center;
    }
    #rec673845808 .tn-elem[data-elem-id="1701164471399"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673845808 .tn-elem[data-elem-id="1701329437802"] {
    color: #006eff;
    z-index: 7;
    top: 550px;
    left: calc(50% - 600px + 460px);
    width: 129px;
  }
  #rec673845808 .tn-elem[data-elem-id="1701329437802"] .tn-atom {
    color: #006eff;
    font-size: 41px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.1;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673845808 .tn-elem[data-elem-id="1701329437802"] {
      top: 784px;
      left: calc(50% - 160px + 96px);
    }
    #rec673845808 .tn-elem[data-elem-id="1701329437802"] {
      text-align: center;
    }
    #rec673845808 .tn-elem[data-elem-id="1701329437802"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec673845808 .tn-elem[data-elem-id="1701329397692"] {
    color: #006eff;
    z-index: 8;
    top: 550px;
    left: calc(50% - 600px + 843px);
    width: 129px;
  }
  #rec673845808 .tn-elem[data-elem-id="1701329397692"] .tn-atom {
    color: #006eff;
    font-size: 41px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.1;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673845808 .tn-elem[data-elem-id="1701329397692"] {
      top: 1239px;
      left: calc(50% - 160px + 96px);
    }
    #rec673845808 .tn-elem[data-elem-id="1701329397692"] {
      text-align: center;
    }
    #rec673845808 .tn-elem[data-elem-id="1701329397692"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec673845808 .tn-elem[data-elem-id="1701329719794"] {
    z-index: 9;
    top: 566px;
    left: calc(50% - 600px + 206px);
    width: 233px;
    height: 14.242053789731px;
  }
  #rec673845808 .tn-elem[data-elem-id="1701329719794"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673845808 .tn-elem[data-elem-id="1701329719794"] {
      top: 132px;
      left: calc(50% - 160px + 811px);
      height: 0px;
    }
  }
  #rec673845808 .tn-elem[data-elem-id="1701329671387"] {
    z-index: 10;
    top: 566px;
    left: calc(50% - 600px + 596px);
    width: 233px;
    height: 14.242053789731px;
  }
  #rec673845808 .tn-elem[data-elem-id="1701329671387"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673845808 .tn-elem[data-elem-id="1701329671387"] {
      top: 177px;
      left: calc(50% - 160px + 827px);
      height: 0px;
    }
  }
  #rec673845808 .tn-elem[data-elem-id="1701603119792"] {
    z-index: 11;
    top: 294px;
    left: calc(50% - 600px + 80px);
    width: 339px;
    height: 226px;
  }
  #rec673845808 .tn-elem[data-elem-id="1701603119792"] .tn-atom {
    border-width: 2px;
    background-position: center center;
    border-color: #006eff;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673845808 .tn-elem[data-elem-id="1701603119792"] {
      top: 124px;
      left: calc(50% - 160px + 11px);
      width: 300px;
      height: 200px;
    }
  }
  #rec673845808 .tn-elem[data-elem-id="1701603168242"] {
    z-index: 12;
    top: 294px;
    left: calc(50% - 600px + 460px);
    width: 339px;
    height: 226px;
  }
  #rec673845808 .tn-elem[data-elem-id="1701603168242"] .tn-atom {
    border-width: 2px;
    background-position: center center;
    border-color: #006eff;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673845808 .tn-elem[data-elem-id="1701603168242"] {
      top: 565px;
      left: calc(50% - 160px + 10px);
      width: 301px;
      height: 200.66666666667px;
    }
  }
  #rec673845808 .tn-elem[data-elem-id="1701603257656"] {
    z-index: 13;
    top: 294px;
    left: calc(50% - 600px + 843px);
    width: 339px;
    height: 226px;
  }
  #rec673845808 .tn-elem[data-elem-id="1701603257656"] .tn-atom {
    border-width: 2px;
    background-position: center center;
    border-color: #006eff;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673845808 .tn-elem[data-elem-id="1701603257656"] {
      top: 1016px;
      left: calc(50% - 160px + 10px);
      width: 301px;
      height: 200.66666666667px;
    }
  }
  #rec673846437 .t396__artboard {
    height: 330px;
    background-color: #006eff;
  }
  #rec673846437 .t396__filter {
    height: 330px;
  }
  #rec673846437 .t396__carrier {
    height: 330px;
    background-position: center center;
    background-attachment: scroll;
    background-size: cover;
    background-repeat: no-repeat;
  }
  @media screen and (max-width: 1199px) {
    #rec673846437 .t396__artboard {
    }
    #rec673846437 .t396__filter {
    }
    #rec673846437 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 959px) {
    #rec673846437 .t396__artboard {
    }
    #rec673846437 .t396__filter {
    }
    #rec673846437 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 639px) {
    #rec673846437 .t396__artboard {
    }
    #rec673846437 .t396__filter {
    }
    #rec673846437 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 479px) {
    #rec673846437 .t396__artboard {
      height: 250px;
    }
    #rec673846437 .t396__filter {
      height: 250px;
    }
    #rec673846437 .t396__carrier {
      height: 250px;
      background-attachment: scroll;
    }
  }
  #rec673846437 .tn-elem[data-elem-id="1701330031869"] {
    color: #ffffff;
    text-align: center;
    z-index: 2;
    top: 42px;
    left: calc(50% - 600px + 257px);
    width: 686px;
  }
  #rec673846437 .tn-elem[data-elem-id="1701330031869"] .tn-atom {
    color: #ffffff;
    font-size: 47px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.2;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673846437 .tn-elem[data-elem-id="1701330031869"] {
      top: 19px;
      left: calc(50% - 160px + 26px);
      width: 268px;
    }
    #rec673846437 .tn-elem[data-elem-id="1701330031869"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec673846437 .tn-elem[data-elem-id="1701604543322"] {
    color: #ffffff;
    z-index: 3;
    top: 205px;
    left: calc(50% - 600px + 433px);
    width: 518px;
  }
  #rec673846437 .tn-elem[data-elem-id="1701604543322"] .tn-atom {
    color: #ffffff;
    font-size: 31px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.6;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673846437 .tn-elem[data-elem-id="1701604543322"] {
      top: 158px;
      left: calc(50% - 160px + 63px);
      width: 225px;
    }
    #rec673846437 .tn-elem[data-elem-id="1701604543322"] .tn-atom {
      font-size: 22px;
      line-height: 2;
    }
  }
  #rec673846437 .tn-elem[data-elem-id="1701604624978"] {
    z-index: 4;
    top: 213px;
    left: calc(50% - 600px + 380px);
    width: 35px;
    height: 35px;
  }
  #rec673846437 .tn-elem[data-elem-id="1701604624978"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673846437 .tn-elem[data-elem-id="1701604624978"] {
      top: 167px;
      left: calc(50% - 160px + 32px);
      width: 24px;
      height: 24px;
    }
  }
  #rec673846437 .tn-elem[data-elem-id="1701604669036"] {
    z-index: 5;
    top: 263px;
    left: calc(50% - 600px + 380px);
    width: 35px;
    height: 35px;
  }
  #rec673846437 .tn-elem[data-elem-id="1701604669036"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673846437 .tn-elem[data-elem-id="1701604669036"] {
      top: 212px;
      left: calc(50% - 160px + 31px);
      width: 24px;
      height: 24px;
    }
  }
  @media (hover: hover), (min-width: 0\0) {
    #rec676036513 .t-submit:hover {
      color: #000000 !important;
      background-color: #ffffff !important;
    }
    #rec676036513 .t-submit:focus-visible {
      color: #000000 !important;
      background-color: #ffffff !important;
    }
  }
  #rec676036513 .t-submit {
    transition-property: background-color, color, border-color, box-shadow;
    transition-duration: 0.2s;
    transition-timing-function: ease-in-out;
  }
  #rec676036513 input::-webkit-input-placeholder {
    color: #000000;
    opacity: 0.5;
  }
  #rec676036513 input::-moz-placeholder {
    color: #000000;
    opacity: 0.5;
  }
  #rec676036513 input:-moz-placeholder {
    color: #000000;
    opacity: 0.5;
  }
  #rec676036513 input:-ms-input-placeholder {
    color: #000000;
    opacity: 0.5;
  }
  #rec676036513 textarea::-webkit-input-placeholder {
    color: #000000;
    opacity: 0.5;
  }
  #rec676036513 textarea::-moz-placeholder {
    color: #000000;
    opacity: 0.5;
  }
  #rec676036513 textarea:-moz-placeholder {
    color: #000000;
    opacity: 0.5;
  }
  #rec676036513 textarea:-ms-input-placeholder {
    color: #000000;
    opacity: 0.5;
  }
  #rec673847246 .t396__artboard {
    height: 850px;
    background-color: #ffffff;
  }
  #rec673847246 .t396__filter {
    height: 850px;
  }
  #rec673847246 .t396__carrier {
    height: 850px;
    background-position: center center;
    background-attachment: scroll;
    background-size: cover;
    background-repeat: no-repeat;
  }
  @media screen and (max-width: 1199px) {
    #rec673847246 .t396__artboard {
    }
    #rec673847246 .t396__filter {
    }
    #rec673847246 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 959px) {
    #rec673847246 .t396__artboard {
    }
    #rec673847246 .t396__filter {
    }
    #rec673847246 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 639px) {
    #rec673847246 .t396__artboard {
    }
    #rec673847246 .t396__filter {
    }
    #rec673847246 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 479px) {
    #rec673847246 .t396__artboard {
      height: 970px;
    }
    #rec673847246 .t396__filter {
      height: 970px;
    }
    #rec673847246 .t396__carrier {
      height: 970px;
      background-attachment: scroll;
    }
  }
  #rec673847246 .tn-elem[data-elem-id="1470209944682"] {
    color: #000000;
    z-index: 2;
    top: 106px;
    left: calc(50% - 600px + 80px);
    width: 931px;
  }
  #rec673847246 .tn-elem[data-elem-id="1470209944682"] .tn-atom {
    color: #000000;
    font-size: 70px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673847246 .tn-elem[data-elem-id="1470209944682"] {
      top: 32px;
      left: calc(50% - 160px + 12px);
      width: 299px;
    }
    #rec673847246 .tn-elem[data-elem-id="1470209944682"] {
      text-align: center;
    }
    #rec673847246 .tn-elem[data-elem-id="1470209944682"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec673847246 .tn-elem[data-elem-id="1701175709584"] {
    color: #000000;
    z-index: 3;
    top: 507px;
    left: calc(50% - 600px + 80px);
    width: 261px;
  }
  #rec673847246 .tn-elem[data-elem-id="1701175709584"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673847246 .tn-elem[data-elem-id="1701175709584"] {
      top: 284px;
      left: calc(50% - 160px + 10px);
      width: 301px;
    }
    #rec673847246 .tn-elem[data-elem-id="1701175709584"] {
      text-align: center;
    }
    #rec673847246 .tn-elem[data-elem-id="1701175709584"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673847246 .tn-elem[data-elem-id="1701164464731"] {
    color: #006eff;
    z-index: 4;
    top: 247px;
    left: calc(50% - 600px + 80px);
    width: 607px;
  }
  #rec673847246 .tn-elem[data-elem-id="1701164464731"] .tn-atom {
    color: #006eff;
    font-size: 41px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.1;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673847246 .tn-elem[data-elem-id="1701164464731"] {
      top: 100px;
      left: calc(50% - 160px + 11px);
      width: 301px;
    }
    #rec673847246 .tn-elem[data-elem-id="1701164464731"] {
      text-align: center;
    }
    #rec673847246 .tn-elem[data-elem-id="1701164464731"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec673847246 .tn-elem[data-elem-id="1701175723418"] {
    color: #000000;
    z-index: 5;
    top: 507px;
    left: calc(50% - 600px + 390px);
    width: 240px;
  }
  #rec673847246 .tn-elem[data-elem-id="1701175723418"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673847246 .tn-elem[data-elem-id="1701175723418"] {
      top: 447px;
      left: calc(50% - 160px + 11px);
      width: 300px;
    }
    #rec673847246 .tn-elem[data-elem-id="1701175723418"] {
      text-align: center;
    }
    #rec673847246 .tn-elem[data-elem-id="1701175723418"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673847246 .tn-elem[data-elem-id="1701176417265"] {
    color: #000000;
    z-index: 6;
    top: 507px;
    left: calc(50% - 600px + 679px);
    width: 217px;
  }
  #rec673847246 .tn-elem[data-elem-id="1701176417265"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673847246 .tn-elem[data-elem-id="1701176417265"] {
      top: 627px;
      left: calc(50% - 160px + 11px);
      width: 300px;
    }
    #rec673847246 .tn-elem[data-elem-id="1701176417265"] {
      text-align: center;
    }
    #rec673847246 .tn-elem[data-elem-id="1701176417265"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673847246 .tn-elem[data-elem-id="1701164471399"] {
    color: #000000;
    z-index: 7;
    top: 507px;
    left: calc(50% - 600px + 945px);
    width: 217px;
  }
  #rec673847246 .tn-elem[data-elem-id="1701164471399"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673847246 .tn-elem[data-elem-id="1701164471399"] {
      top: 821px;
      left: calc(50% - 160px + 10px);
      width: 301px;
    }
    #rec673847246 .tn-elem[data-elem-id="1701164471399"] {
      text-align: center;
    }
    #rec673847246 .tn-elem[data-elem-id="1701164471399"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673847246 .tn-elem[data-elem-id="1701605387336"] {
    z-index: 8;
    top: 430px;
    left: calc(50% - 600px + 390px);
    width: 52px;
    height: 52px;
  }
  #rec673847246 .tn-elem[data-elem-id="1701605387336"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673847246 .tn-elem[data-elem-id="1701605387336"] {
      top: 405px;
      left: calc(50% - 160px + 144px);
      width: 32px;
      height: 32px;
    }
  }
  #rec673847246 .tn-elem[data-elem-id="1701605396383"] {
    z-index: 9;
    top: 430px;
    left: calc(50% - 600px + 81px);
    width: 52px;
    height: 52px;
  }
  #rec673847246 .tn-elem[data-elem-id="1701605396383"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673847246 .tn-elem[data-elem-id="1701605396383"] {
      top: 237px;
      left: calc(50% - 160px + 144px);
      width: 32px;
      height: 32px;
    }
  }
  #rec673847246 .tn-elem[data-elem-id="1701605406001"] {
    z-index: 10;
    top: 430px;
    left: calc(50% - 600px + 952px);
    width: 52px;
    height: 52px;
  }
  #rec673847246 .tn-elem[data-elem-id="1701605406001"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673847246 .tn-elem[data-elem-id="1701605406001"] {
      top: 775px;
      left: calc(50% - 160px + 144px);
      width: 32px;
      height: 32px;
    }
  }
  #rec673847246 .tn-elem[data-elem-id="1701605412885"] {
    z-index: 11;
    top: 430px;
    left: calc(50% - 600px + 679px);
    width: 52px;
    height: 52px;
  }
  #rec673847246 .tn-elem[data-elem-id="1701605412885"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673847246 .tn-elem[data-elem-id="1701605412885"] {
      top: 583px;
      left: calc(50% - 160px + 144px);
      width: 32px;
      height: 32px;
    }
  }
  #rec675753187 .t396__artboard {
    height: 10px;
    background-color: #8a76ff;
  }
  #rec675753187 .t396__filter {
    height: 10px;
  }
  #rec675753187 .t396__carrier {
    height: 10px;
    background-position: center center;
    background-attachment: scroll;
    background-size: cover;
    background-repeat: no-repeat;
  }
  @media screen and (max-width: 1199px) {
    #rec675753187 .t396__artboard {
    }
    #rec675753187 .t396__filter {
    }
    #rec675753187 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 959px) {
    #rec675753187 .t396__artboard {
    }
    #rec675753187 .t396__filter {
    }
    #rec675753187 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 639px) {
    #rec675753187 .t396__artboard {
    }
    #rec675753187 .t396__filter {
    }
    #rec675753187 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 479px) {
    #rec675753187 .t396__artboard {
    }
    #rec675753187 .t396__filter {
    }
    #rec675753187 .t396__carrier {
      background-attachment: scroll;
    }
  }
  #rec673848691 .t396__artboard {
    height: 2240px;
    background-color: #ffffff;
  }
  #rec673848691 .t396__filter {
    height: 2240px;
  }
  #rec673848691 .t396__carrier {
    height: 2240px;
    background-position: center center;
    background-attachment: scroll;
    background-size: cover;
    background-repeat: no-repeat;
  }
  @media screen and (max-width: 1199px) {
    #rec673848691 .t396__artboard {
    }
    #rec673848691 .t396__filter {
    }
    #rec673848691 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 959px) {
    #rec673848691 .t396__artboard {
    }
    #rec673848691 .t396__filter {
    }
    #rec673848691 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 639px) {
    #rec673848691 .t396__artboard {
    }
    #rec673848691 .t396__filter {
    }
    #rec673848691 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 479px) {
    #rec673848691 .t396__artboard {
      height: 1440px;
    }
    #rec673848691 .t396__filter {
      height: 1440px;
    }
    #rec673848691 .t396__carrier {
      height: 1440px;
      background-attachment: scroll;
    }
  }
  #rec673848691 .tn-elem[data-elem-id="1470209944682"] {
    color: #000000;
    z-index: 2;
    top: 59px;
    left: calc(50% - 600px + 80px);
    width: 931px;
  }
  #rec673848691 .tn-elem[data-elem-id="1470209944682"] .tn-atom {
    color: #000000;
    font-size: 70px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673848691 .tn-elem[data-elem-id="1470209944682"] {
      top: 32px;
      left: calc(50% - 160px + 44px);
      width: 233px;
    }
    #rec673848691 .tn-elem[data-elem-id="1470209944682"] {
      text-align: center;
    }
    #rec673848691 .tn-elem[data-elem-id="1470209944682"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec673848691 .tn-elem[data-elem-id="1701175709584"] {
    color: #000000;
    text-align: right;
    z-index: 3;
    top: 433px;
    left: calc(50% - 600px + 120px);
    width: 261px;
  }
  #rec673848691 .tn-elem[data-elem-id="1701175709584"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673848691 .tn-elem[data-elem-id="1701175709584"] {
      top: 504px;
      left: calc(50% - 160px + 30px);
    }
    #rec673848691 .tn-elem[data-elem-id="1701175709584"] {
      text-align: center;
    }
    #rec673848691 .tn-elem[data-elem-id="1701175709584"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673848691 .tn-elem[data-elem-id="1701164464731"] {
    color: #006eff;
    z-index: 4;
    top: 231px;
    left: calc(50% - 600px + 80px);
    width: 781px;
  }
  #rec673848691 .tn-elem[data-elem-id="1701164464731"] .tn-atom {
    color: #006eff;
    font-size: 41px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.1;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673848691 .tn-elem[data-elem-id="1701164464731"] {
      top: 110px;
      left: calc(50% - 160px + 10px);
      width: 302px;
    }
    #rec673848691 .tn-elem[data-elem-id="1701164464731"] {
      text-align: center;
    }
    #rec673848691 .tn-elem[data-elem-id="1701164464731"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec673848691 .tn-elem[data-elem-id="1701175723418"] {
    color: #000000;
    z-index: 5;
    top: 1007px;
    left: calc(50% - 600px + 846px);
    width: 252px;
  }
  #rec673848691 .tn-elem[data-elem-id="1701175723418"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673848691 .tn-elem[data-elem-id="1701175723418"] {
      top: 872px;
      left: calc(50% - 160px + 34px);
    }
    #rec673848691 .tn-elem[data-elem-id="1701175723418"] {
      text-align: center;
    }
    #rec673848691 .tn-elem[data-elem-id="1701175723418"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673848691 .tn-elem[data-elem-id="1701176417265"] {
    color: #000000;
    text-align: right;
    z-index: 6;
    top: 1591px;
    left: calc(50% - 600px + 122px);
    width: 259px;
  }
  #rec673848691 .tn-elem[data-elem-id="1701176417265"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673848691 .tn-elem[data-elem-id="1701176417265"] {
      top: 1285px;
      left: calc(50% - 160px + 25px);
    }
    #rec673848691 .tn-elem[data-elem-id="1701176417265"] {
      text-align: center;
    }
    #rec673848691 .tn-elem[data-elem-id="1701176417265"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673848691 .tn-elem[data-elem-id="1701332169204"] {
    z-index: 7;
    top: 433px;
    left: calc(50% - 600px + 420px);
    width: 717px;
    height: 510.10447761194px;
  }
  #rec673848691 .tn-elem[data-elem-id="1701332169204"] .tn-atom {
    border-width: 2px;
    border-radius: 20px;
    overflow: hidden;
    background-position: center center;
    border-color: #006eff;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673848691 .tn-elem[data-elem-id="1701332169204"] {
      top: 270px;
      left: calc(50% - 160px + 10px);
      width: 300px;
      height: 213.4328358209px;
      border-radius: 10px;
    }
    #rec673848691 .tn-elem[data-elem-id="1701332169204"] .tn-atom {
      border-radius: 10px;
    }
    #rec673848691 .tn-elem[data-elem-id="1701332169204"] .tn-atom__img {
      border-radius: 10px;
    }
  }
  #rec673848691 .tn-elem[data-elem-id="1701332185740"] {
    z-index: 8;
    top: 1007px;
    left: calc(50% - 600px + 80px);
    width: 717px;
    height: 510.10447761194px;
  }
  #rec673848691 .tn-elem[data-elem-id="1701332185740"] .tn-atom {
    border-width: 2px;
    border-radius: 20px;
    overflow: hidden;
    background-position: center center;
    border-color: #006eff;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673848691 .tn-elem[data-elem-id="1701332185740"] {
      top: 637px;
      left: calc(50% - 160px + 10px);
      width: 300px;
      height: 213.4328358209px;
      border-radius: 10px;
    }
    #rec673848691 .tn-elem[data-elem-id="1701332185740"] .tn-atom {
      border-radius: 10px;
    }
    #rec673848691 .tn-elem[data-elem-id="1701332185740"] .tn-atom__img {
      border-radius: 10px;
    }
  }
  #rec673848691 .tn-elem[data-elem-id="1701332028869"] {
    z-index: 9;
    top: 1591px;
    left: calc(50% - 600px + 419px);
    width: 717px;
    height: 550.50561797753px;
  }
  #rec673848691 .tn-elem[data-elem-id="1701332028869"] .tn-atom {
    border-width: 2px;
    border-radius: 20px;
    overflow: hidden;
    background-position: center center;
    border-color: #006eff;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673848691 .tn-elem[data-elem-id="1701332028869"] {
      top: 1026px;
      left: calc(50% - 160px + 10px);
      width: 300px;
      height: 230.33707865169px;
      border-radius: 10px;
    }
    #rec673848691 .tn-elem[data-elem-id="1701332028869"] .tn-atom {
      border-radius: 10px;
    }
    #rec673848691 .tn-elem[data-elem-id="1701332028869"] .tn-atom__img {
      border-radius: 10px;
    }
  }
  #rec675753199 .t396__artboard {
    height: 10px;
    background-color: #8a76ff;
  }
  #rec675753199 .t396__filter {
    height: 10px;
  }
  #rec675753199 .t396__carrier {
    height: 10px;
    background-position: center center;
    background-attachment: scroll;
    background-size: cover;
    background-repeat: no-repeat;
  }
  @media screen and (max-width: 1199px) {
    #rec675753199 .t396__artboard {
    }
    #rec675753199 .t396__filter {
    }
    #rec675753199 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 959px) {
    #rec675753199 .t396__artboard {
    }
    #rec675753199 .t396__filter {
    }
    #rec675753199 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 639px) {
    #rec675753199 .t396__artboard {
    }
    #rec675753199 .t396__filter {
    }
    #rec675753199 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 479px) {
    #rec675753199 .t396__artboard {
    }
    #rec675753199 .t396__filter {
    }
    #rec675753199 .t396__carrier {
      background-attachment: scroll;
    }
  }
  #rec673852235 .t396__artboard {
    height: 880px;
    background-color: #ffffff;
  }
  #rec673852235 .t396__filter {
    height: 880px;
  }
  #rec673852235 .t396__carrier {
    height: 880px;
    background-position: center center;
    background-attachment: scroll;
    background-size: cover;
    background-repeat: no-repeat;
  }
  @media screen and (max-width: 1199px) {
    #rec673852235 .t396__artboard {
    }
    #rec673852235 .t396__filter {
    }
    #rec673852235 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 959px) {
    #rec673852235 .t396__artboard {
    }
    #rec673852235 .t396__filter {
    }
    #rec673852235 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 639px) {
    #rec673852235 .t396__artboard {
    }
    #rec673852235 .t396__filter {
    }
    #rec673852235 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 479px) {
    #rec673852235 .t396__artboard {
      height: 790px;
    }
    #rec673852235 .t396__filter {
      height: 790px;
    }
    #rec673852235 .t396__carrier {
      height: 790px;
      background-attachment: scroll;
    }
  }
  #rec673852235 .tn-elem[data-elem-id="1701332885841"] {
    z-index: 2;
    top: 451px;
    left: calc(50% - 600px + 80px);
    width: 341px;
    height: 229px;
  }
  #rec673852235 .tn-elem[data-elem-id="1701332885841"] .tn-atom {
    border-radius: 50px;
    background-color: #e9edf5;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673852235 .tn-elem[data-elem-id="1701332885841"] {
      top: 225px;
      left: calc(50% - 160px + 0px);
      width: 320px;
      height: 176px;
    }
  }
  #rec673852235 .tn-elem[data-elem-id="1701332885844"] {
    z-index: 3;
    top: 451px;
    left: calc(50% - 600px + 439px);
    width: 359px;
    height: 229px;
  }
  #rec673852235 .tn-elem[data-elem-id="1701332885844"] .tn-atom {
    border-radius: 50px;
    background-color: #f3f3f3;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673852235 .tn-elem[data-elem-id="1701332885844"] {
      top: 411px;
      left: calc(50% - 160px + 0px);
      width: 320px;
      height: 176px;
    }
  }
  #rec673852235 .tn-elem[data-elem-id="1701332885846"] {
    z-index: 4;
    top: 451px;
    left: calc(50% - 600px + 815px);
    width: 341px;
    height: 229px;
  }
  #rec673852235 .tn-elem[data-elem-id="1701332885846"] .tn-atom {
    border-radius: 50px;
    background-color: #e9edf5;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673852235 .tn-elem[data-elem-id="1701332885846"] {
      top: 597px;
      left: calc(50% - 160px + 0px);
      width: 320px;
      height: 176px;
    }
  }
  #rec673852235 .tn-elem[data-elem-id="1470209944682"] {
    color: #000000;
    z-index: 5;
    top: 114px;
    left: calc(50% - 600px + 80px);
    width: 931px;
  }
  #rec673852235 .tn-elem[data-elem-id="1470209944682"] .tn-atom {
    color: #000000;
    font-size: 70px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673852235 .tn-elem[data-elem-id="1470209944682"] {
      top: 29px;
      left: calc(50% - 160px + 55px);
      width: 210px;
    }
    #rec673852235 .tn-elem[data-elem-id="1470209944682"] {
      text-align: center;
    }
    #rec673852235 .tn-elem[data-elem-id="1470209944682"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec673852235 .tn-elem[data-elem-id="1701175709584"] {
    color: #000000;
    z-index: 6;
    top: 488px;
    left: calc(50% - 600px + 120px);
    width: 262px;
  }
  #rec673852235 .tn-elem[data-elem-id="1701175709584"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673852235 .tn-elem[data-elem-id="1701175709584"] {
      top: 262px;
      left: calc(50% - 160px + 29px);
    }
    #rec673852235 .tn-elem[data-elem-id="1701175709584"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673852235 .tn-elem[data-elem-id="1701164464731"] {
    color: #006eff;
    z-index: 7;
    top: 262px;
    left: calc(50% - 600px + 80px);
    width: 781px;
  }
  #rec673852235 .tn-elem[data-elem-id="1701164464731"] .tn-atom {
    color: #006eff;
    font-size: 41px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.1;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673852235 .tn-elem[data-elem-id="1701164464731"] {
      top: 110px;
      left: calc(50% - 160px + 40px);
      width: 240px;
    }
    #rec673852235 .tn-elem[data-elem-id="1701164464731"] {
      text-align: center;
    }
    #rec673852235 .tn-elem[data-elem-id="1701164464731"] .tn-atom {
      font-size: 20px;
    }
  }
  #rec673852235 .tn-elem[data-elem-id="1701175723418"] {
    color: #000000;
    z-index: 8;
    top: 488px;
    left: calc(50% - 600px + 498px);
    width: 240px;
  }
  #rec673852235 .tn-elem[data-elem-id="1701175723418"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673852235 .tn-elem[data-elem-id="1701175723418"] {
      top: 448px;
      left: calc(50% - 160px + 29px);
    }
    #rec673852235 .tn-elem[data-elem-id="1701175723418"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673852235 .tn-elem[data-elem-id="1701176417265"] {
    color: #000000;
    z-index: 9;
    top: 488px;
    left: calc(50% - 600px + 884px);
    width: 217px;
  }
  #rec673852235 .tn-elem[data-elem-id="1701176417265"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673852235 .tn-elem[data-elem-id="1701176417265"] {
      top: 634px;
      left: calc(50% - 160px + 29px);
    }
    #rec673852235 .tn-elem[data-elem-id="1701176417265"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673852235 .tn-elem[data-elem-id="1701333074526"] {
    z-index: 10;
    top: 700px;
    left: calc(50% - 600px + 320px);
    width: 154px;
    height: 133.52127659574px;
  }
  #rec673852235 .tn-elem[data-elem-id="1701333074526"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673852235 .tn-elem[data-elem-id="1701333074526"] {
      top: 569px;
      left: calc(50% - 160px + 224px);
      width: 75px;
      height: 65.026595744681px;
    }
  }
  #rec673852235 .tn-elem[data-elem-id="1701332939537"] {
    z-index: 11;
    top: 382px;
    left: calc(50% - 600px + 1042px);
    width: 114px;
    height: 80.91825613079px;
  }
  #rec673852235 .tn-elem[data-elem-id="1701332939537"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673852235 .tn-elem[data-elem-id="1701332939537"] {
      top: 384px;
      left: calc(50% - 160px + 205px);
      width: 77px;
      height: 54.655313351499px;
    }
  }
  #rec673853286 .t396__artboard {
    height: 970px;
    background-color: #ffffff;
  }
  #rec673853286 .t396__filter {
    height: 970px;
  }
  #rec673853286 .t396__carrier {
    height: 970px;
    background-position: center center;
    background-attachment: scroll;
    background-size: cover;
    background-repeat: no-repeat;
  }
  @media screen and (max-width: 1199px) {
    #rec673853286 .t396__artboard {
    }
    #rec673853286 .t396__filter {
    }
    #rec673853286 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 959px) {
    #rec673853286 .t396__artboard {
    }
    #rec673853286 .t396__filter {
    }
    #rec673853286 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 639px) {
    #rec673853286 .t396__artboard {
    }
    #rec673853286 .t396__filter {
    }
    #rec673853286 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .t396__artboard {
      height: 1530px;
    }
    #rec673853286 .t396__filter {
      height: 1530px;
    }
    #rec673853286 .t396__carrier {
      height: 1530px;
      background-attachment: scroll;
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701340968416"] {
    z-index: 2;
    top: 331px;
    left: calc(50% - 600px + 20px);
    width: 362px;
    height: 549px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701340968416"] .tn-atom {
    border-width: 2px;
    border-radius: 50px;
    background-color: #ffffff;
    background-position: center center;
    border-color: #006eff;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701340968416"] {
      top: 154px;
      left: calc(50% - 160px + 0px);
      width: 321px;
      height: 382px;
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701340927203"] {
    z-index: 3;
    top: 331px;
    left: calc(50% - 600px + 820px);
    width: 362px;
    height: 549px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701340927203"] .tn-atom {
    border-width: 2px;
    border-radius: 50px;
    background-color: #ffffff;
    background-position: center center;
    border-color: #006eff;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701340927203"] {
      top: 1015px;
      left: calc(50% - 160px + 0px);
      width: 320px;
      height: 470px;
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701340985837"] {
    z-index: 4;
    top: 331px;
    left: calc(50% - 600px + 420px);
    width: 362px;
    height: 549px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701340985837"] .tn-atom {
    border-width: 2px;
    border-radius: 50px;
    background-color: #ffffff;
    background-position: center center;
    border-color: #006eff;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701340985837"] {
      top: 554px;
      left: calc(50% - 160px + 0px);
      width: 321px;
      height: 432px;
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701340977770"] {
    z-index: 5;
    top: 914px;
    left: calc(50% - 600px + 20px);
    width: 760px;
    height: 512px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701340977770"] .tn-atom {
    border-width: 2px;
    border-radius: 50px;
    background-color: #ffffff;
    background-position: center center;
    border-color: #006eff;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701340977770"] {
      top: 1511px;
      left: calc(50% - 160px + 0px);
      width: 320px;
      height: 566px;
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1470209944682"] {
    color: #000000;
    text-align: center;
    z-index: 6;
    top: 114px;
    left: calc(50% - 600px + 135px);
    width: 931px;
  }
  #rec673853286 .tn-elem[data-elem-id="1470209944682"] .tn-atom {
    color: #000000;
    font-size: 70px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1470209944682"] {
      top: 35px;
      left: calc(50% - 160px + 43px);
      width: 234px;
    }
    #rec673853286 .tn-elem[data-elem-id="1470209944682"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701164464731"] {
    color: #006eff;
    text-align: center;
    z-index: 7;
    top: 211px;
    left: calc(50% - 600px + 345px);
    width: 510px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701164464731"] .tn-atom {
    color: #006eff;
    font-size: 41px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.1;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701164464731"] {
      top: 77px;
      left: calc(50% - 160px + 37px);
      width: 246px;
    }
    #rec673853286 .tn-elem[data-elem-id="1701164464731"] .tn-atom {
      font-size: 20px;
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701340529940"] {
    color: #000000;
    z-index: 8;
    top: 346px;
    left: calc(50% - 600px + 60px);
    width: 115px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701340529940"] .tn-atom {
    color: #000000;
    font-size: 35px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701340529940"] {
      top: 169px;
      left: calc(50% - 160px + 103px);
    }
    #rec673853286 .tn-elem[data-elem-id="1701340529940"] {
      text-align: center;
    }
    #rec673853286 .tn-elem[data-elem-id="1701340529940"] .tn-atom {
      font-size: 20px;
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701340567255"] {
    color: #000000;
    z-index: 9;
    top: 539px;
    left: calc(50% - 600px + 60px);
    width: 279px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701340567255"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701340567255"] {
      top: 263px;
      left: calc(50% - 160px + 48px);
      width: 224px;
    }
    #rec673853286 .tn-elem[data-elem-id="1701340567255"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701340718235"] {
    color: #000000;
    z-index: 10;
    top: 953px;
    left: calc(50% - 600px + 80px);
    width: 115px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701340718235"] .tn-atom {
    color: #000000;
    font-size: 35px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701340718235"] {
      top: 1533px;
      left: calc(50% - 160px + 103px);
    }
    #rec673853286 .tn-elem[data-elem-id="1701340718235"] {
      text-align: center;
    }
    #rec673853286 .tn-elem[data-elem-id="1701340718235"] .tn-atom {
      font-size: 20px;
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701340824011"] {
    color: #000000;
    z-index: 11;
    top: 1133px;
    left: calc(50% - 600px + 80px);
    width: 330px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701340824011"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701340824011"] {
      top: 1632px;
      left: calc(50% - 160px + 48px);
      width: 262px;
    }
    #rec673853286 .tn-elem[data-elem-id="1701340824011"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701340718237"] {
    color: #000000;
    z-index: 12;
    top: 1133px;
    left: calc(50% - 600px + 410px);
    width: 240px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701340718237"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701340718237"] {
      top: 1781px;
      left: calc(50% - 160px + 48px);
    }
    #rec673853286 .tn-elem[data-elem-id="1701340718237"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701340605854"] {
    color: #000000;
    z-index: 13;
    top: 346px;
    left: calc(50% - 600px + 461px);
    width: 115px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701340605854"] .tn-atom {
    color: #000000;
    font-size: 35px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701340605854"] {
      top: 569px;
      left: calc(50% - 160px + 103px);
    }
    #rec673853286 .tn-elem[data-elem-id="1701340605854"] {
      text-align: center;
    }
    #rec673853286 .tn-elem[data-elem-id="1701340605854"] .tn-atom {
      font-size: 20px;
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701340605855"] {
    color: #000000;
    z-index: 14;
    top: 539px;
    left: calc(50% - 600px + 461px);
    width: 299px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701340605855"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701340605855"] {
      top: 665px;
      left: calc(50% - 160px + 48px);
      width: 236px;
    }
    #rec673853286 .tn-elem[data-elem-id="1701340605855"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701340674345"] {
    color: #000000;
    z-index: 15;
    top: 346px;
    left: calc(50% - 600px + 882px);
    width: 115px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701340674345"] .tn-atom {
    color: #000000;
    font-size: 35px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701340674345"] {
      top: 1030px;
      left: calc(50% - 160px + 103px);
    }
    #rec673853286 .tn-elem[data-elem-id="1701340674345"] {
      text-align: center;
    }
    #rec673853286 .tn-elem[data-elem-id="1701340674345"] .tn-atom {
      font-size: 20px;
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701340674347"] {
    color: #000000;
    z-index: 16;
    top: 539px;
    left: calc(50% - 600px + 882px);
    width: 299px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701340674347"] .tn-atom {
    color: #000000;
    font-size: 20px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701340674347"] {
      top: 1135px;
      left: calc(50% - 160px + 48px);
      width: 241px;
    }
    #rec673853286 .tn-elem[data-elem-id="1701340674347"] .tn-atom {
      font-size: 16px;
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701341099837"] {
    color: #ffffff;
    text-align: center;
    z-index: 17;
    top: 796px;
    left: calc(50% - 600px + 62px);
    width: 279px;
    height: 53px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701341099837"] .tn-atom {
    color: #ffffff;
    font-size: 16px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 600;
    text-transform: uppercase;
    border-radius: 10px;
    background-color: #000000;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
    transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
      border-color 0.2s ease-in-out;
  }
  @media (hover), (min-width: 0\0) {
    #rec673853286 .tn-elem[data-elem-id="1701341099837"] .tn-atom:hover {
      background-color: #000ec8;
      background-image: none;
    }
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701341099837"] {
      top: 440px;
      left: calc(50% - 160px + 21px);
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701341114021"] {
    color: #ffffff;
    text-align: center;
    z-index: 18;
    top: 796px;
    left: calc(50% - 600px + 462px);
    width: 279px;
    height: 53px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701341114021"] .tn-atom {
    color: #ffffff;
    font-size: 16px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 600;
    text-transform: uppercase;
    border-radius: 10px;
    background-color: #000000;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
    transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
      border-color 0.2s ease-in-out;
  }
  @media (hover), (min-width: 0\0) {
    #rec673853286 .tn-elem[data-elem-id="1701341114021"] .tn-atom:hover {
      background-color: #000ec8;
      background-image: none;
    }
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701341114021"] {
      top: 898px;
      left: calc(50% - 160px + 21px);
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701341132441"] {
    color: #ffffff;
    text-align: center;
    z-index: 19;
    top: 796px;
    left: calc(50% - 600px + 862px);
    width: 279px;
    height: 53px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701341132441"] .tn-atom {
    color: #ffffff;
    font-size: 16px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 600;
    text-transform: uppercase;
    border-radius: 10px;
    background-color: #000000;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
    transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
      border-color 0.2s ease-in-out;
  }
  @media (hover), (min-width: 0\0) {
    #rec673853286 .tn-elem[data-elem-id="1701341132441"] .tn-atom:hover {
      background-color: #000ec8;
      background-image: none;
    }
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701341132441"] {
      top: 1394px;
      left: calc(50% - 160px + 21px);
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701341060764"] {
    color: #ffffff;
    text-align: center;
    z-index: 20;
    top: 1344px;
    left: calc(50% - 600px + 80px);
    width: 204px;
    height: 53px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701341060764"] .tn-atom {
    color: #ffffff;
    font-size: 16px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 600;
    text-transform: uppercase;
    border-radius: 60px;
    background-color: #000000;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
    transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
      border-color 0.2s ease-in-out;
  }
  @media (hover), (min-width: 0\0) {
    #rec673853286 .tn-elem[data-elem-id="1701341060764"] .tn-atom:hover {
      background-color: #000ec8;
      background-image: none;
    }
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701341060764"] {
      top: 1989px;
      left: calc(50% - 160px + 58px);
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701515986900"] {
    z-index: 21;
    top: 128px;
    left: calc(50% - 600px + 200px);
    width: 128px;
    height: 170.66666666667px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701515986900"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701515986900"] {
      top: 254px;
      left: calc(50% - 160px + 251px);
      width: 68px;
      height: 90.666666666667px;
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701516018586"] {
    z-index: 22;
    top: 956px;
    left: calc(50% - 600px + 796px);
    width: 154px;
    height: 205.33333333333px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701516018586"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701516018586"] {
      top: 1283px;
      left: calc(50% - 160px + 232px);
      width: 71px;
      height: 94.666666666667px;
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701175709584"] {
    color: #000000;
    text-align: center;
    z-index: 23;
    top: 400px;
    left: calc(50% - 600px + 60px);
    width: 163px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701175709584"] .tn-atom {
    color: #000000;
    font-size: 48px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701175709584"] {
      top: 200px;
      left: calc(50% - 160px + 43px);
      width: 105px;
    }
    #rec673853286 .tn-elem[data-elem-id="1701175709584"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701340605851"] {
    color: #000000;
    text-align: center;
    z-index: 24;
    top: 400px;
    left: calc(50% - 600px + 461px);
    width: 163px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701340605851"] .tn-atom {
    color: #000000;
    font-size: 48px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701340605851"] {
      top: 602px;
      left: calc(50% - 160px + 46px);
      width: 99px;
    }
    #rec673853286 .tn-elem[data-elem-id="1701340605851"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701605891839"] {
    color: #006eff;
    z-index: 25;
    top: 474px;
    left: calc(50% - 600px + 60px);
    width: 241px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701605891839"] .tn-atom {
    color: #006eff;
    font-size: 35px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701605891839"] {
      top: 200px;
      left: calc(50% - 160px + 148px);
      width: 129px;
    }
    #rec673853286 .tn-elem[data-elem-id="1701605891839"] {
      text-align: center;
    }
    #rec673853286 .tn-elem[data-elem-id="1701605891839"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701605950265"] {
    color: #006eff;
    z-index: 26;
    top: 474px;
    left: calc(50% - 600px + 461px);
    width: 241px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701605950265"] .tn-atom {
    color: #006eff;
    font-size: 35px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701605950265"] {
      top: 602px;
      left: calc(50% - 160px + 146px);
      width: 128px;
    }
    #rec673853286 .tn-elem[data-elem-id="1701605950265"] {
      text-align: left;
    }
    #rec673853286 .tn-elem[data-elem-id="1701605950265"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701340674343"] {
    color: #000000;
    text-align: center;
    z-index: 27;
    top: 400px;
    left: calc(50% - 600px + 882px);
    width: 163px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701340674343"] .tn-atom {
    color: #000000;
    font-size: 48px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701340674343"] {
      top: 1063px;
      left: calc(50% - 160px + 29px);
      width: 114px;
    }
    #rec673853286 .tn-elem[data-elem-id="1701340674343"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701605967184"] {
    color: #006eff;
    z-index: 28;
    top: 474px;
    left: calc(50% - 600px + 882px);
    width: 241px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701605967184"] .tn-atom {
    color: #006eff;
    font-size: 35px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701605967184"] {
      top: 1063px;
      left: calc(50% - 160px + 144px);
      width: 146px;
    }
    #rec673853286 .tn-elem[data-elem-id="1701605967184"] {
      text-align: center;
    }
    #rec673853286 .tn-elem[data-elem-id="1701605967184"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701340718239"] {
    color: #000000;
    text-align: center;
    z-index: 29;
    top: 1007px;
    left: calc(50% - 600px + 80px);
    width: 163px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701340718239"] .tn-atom {
    color: #000000;
    font-size: 48px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701340718239"] {
      top: 1568px;
      left: calc(50% - 160px + 27px);
      width: 111px;
    }
    #rec673853286 .tn-elem[data-elem-id="1701340718239"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec673853286 .tn-elem[data-elem-id="1701605984771"] {
    color: #006eff;
    z-index: 30;
    top: 1073px;
    left: calc(50% - 600px + 80px);
    width: 241px;
  }
  #rec673853286 .tn-elem[data-elem-id="1701605984771"] .tn-atom {
    color: #006eff;
    font-size: 35px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec673853286 .tn-elem[data-elem-id="1701605984771"] {
      top: 1568px;
      left: calc(50% - 160px + 138px);
      width: 148px;
    }
    #rec673853286 .tn-elem[data-elem-id="1701605984771"] {
      text-align: center;
    }
    #rec673853286 .tn-elem[data-elem-id="1701605984771"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec675753249 .t396__artboard {
    height: 10px;
    background-color: #8a76ff;
  }
  #rec675753249 .t396__filter {
    height: 10px;
  }
  #rec675753249 .t396__carrier {
    height: 10px;
    background-position: center center;
    background-attachment: scroll;
    background-size: cover;
    background-repeat: no-repeat;
  }
  @media screen and (max-width: 1199px) {
    #rec675753249 .t396__artboard {
    }
    #rec675753249 .t396__filter {
    }
    #rec675753249 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 959px) {
    #rec675753249 .t396__artboard {
    }
    #rec675753249 .t396__filter {
    }
    #rec675753249 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 639px) {
    #rec675753249 .t396__artboard {
    }
    #rec675753249 .t396__filter {
    }
    #rec675753249 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 479px) {
    #rec675753249 .t396__artboard {
    }
    #rec675753249 .t396__filter {
    }
    #rec675753249 .t396__carrier {
      background-attachment: scroll;
    }
  }
  #rec674784807 .t396__artboard {
    height: 250px;
    background-color: #ffffff;
  }
  #rec674784807 .t396__filter {
    height: 250px;
  }
  #rec674784807 .t396__carrier {
    height: 250px;
    background-position: center center;
    background-attachment: scroll;
    background-size: cover;
    background-repeat: no-repeat;
  }
  @media screen and (max-width: 1199px) {
    #rec674784807 .t396__artboard {
    }
    #rec674784807 .t396__filter {
    }
    #rec674784807 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 959px) {
    #rec674784807 .t396__artboard {
    }
    #rec674784807 .t396__filter {
    }
    #rec674784807 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 639px) {
    #rec674784807 .t396__artboard {
    }
    #rec674784807 .t396__filter {
    }
    #rec674784807 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 479px) {
    #rec674784807 .t396__artboard {
      height: 110px;
    }
    #rec674784807 .t396__filter {
      height: 110px;
    }
    #rec674784807 .t396__carrier {
      height: 110px;
      background-attachment: scroll;
    }
  }
  #rec674784807 .tn-elem[data-elem-id="1470209944682"] {
    color: #000000;
    text-align: center;
    z-index: 2;
    top: 63px;
    left: calc(50% - 600px + 135px);
    width: 931px;
  }
  #rec674784807 .tn-elem[data-elem-id="1470209944682"] .tn-atom {
    color: #000000;
    font-size: 70px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec674784807 .tn-elem[data-elem-id="1470209944682"] {
      top: 40px;
      left: calc(50% - 160px + 130px);
      width: 60px;
    }
    #rec674784807 .tn-elem[data-elem-id="1470209944682"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec674784807 .tn-elem[data-elem-id="1701164464731"] {
    color: #006eff;
    text-align: center;
    z-index: 3;
    top: 178px;
    left: calc(50% - 600px + 320px);
    width: 561px;
  }
  #rec674784807 .tn-elem[data-elem-id="1701164464731"] .tn-atom {
    color: #006eff;
    font-size: 41px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.1;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec674784807 .tn-elem[data-elem-id="1701164464731"] {
      top: 86px;
      left: calc(50% - 160px + 23px);
      width: 275px;
    }
    #rec674784807 .tn-elem[data-elem-id="1701164464731"] .tn-atom {
      font-size: 20px;
    }
  }
  #rec673857212 .t585__title {
    font-size: 20px;
  }
  #rec673857212 .t585__text {
    font-size: 20px;
  }
  #rec674787669 .t396__artboard {
    height: 130px;
    background-color: #ffffff;
  }
  #rec674787669 .t396__filter {
    height: 130px;
  }
  #rec674787669 .t396__carrier {
    height: 130px;
    background-position: center center;
    background-attachment: scroll;
    background-size: cover;
    background-repeat: no-repeat;
  }
  @media screen and (max-width: 1199px) {
    #rec674787669 .t396__artboard {
    }
    #rec674787669 .t396__filter {
    }
    #rec674787669 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 959px) {
    #rec674787669 .t396__artboard {
    }
    #rec674787669 .t396__filter {
    }
    #rec674787669 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 639px) {
    #rec674787669 .t396__artboard {
    }
    #rec674787669 .t396__filter {
    }
    #rec674787669 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 479px) {
    #rec674787669 .t396__artboard {
      height: 30px;
    }
    #rec674787669 .t396__filter {
      height: 30px;
    }
    #rec674787669 .t396__carrier {
      height: 30px;
      background-attachment: scroll;
    }
  }
  #rec674787669 .tn-elem[data-elem-id="1701164464731"] {
    color: #006eff;
    text-align: center;
    z-index: 2;
    top: 70px;
    left: calc(50% - 600px + 320px);
    width: 561px;
  }
  #rec674787669 .tn-elem[data-elem-id="1701164464731"] .tn-atom {
    color: #006eff;
    font-size: 41px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.1;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec674787669 .tn-elem[data-elem-id="1701164464731"] {
      top: -3px;
      left: calc(50% - 160px + -120px);
    }
    #rec674787669 .tn-elem[data-elem-id="1701164464731"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec674800383 .t585__title {
    font-size: 20px;
  }
  #rec674800383 .t585__text {
    font-size: 20px;
  }
  #rec674800315 .t396__artboard {
    height: 130px;
    background-color: #ffffff;
  }
  #rec674800315 .t396__filter {
    height: 130px;
  }
  #rec674800315 .t396__carrier {
    height: 130px;
    background-position: center center;
    background-attachment: scroll;
    background-size: cover;
    background-repeat: no-repeat;
  }
  @media screen and (max-width: 1199px) {
    #rec674800315 .t396__artboard {
    }
    #rec674800315 .t396__filter {
    }
    #rec674800315 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 959px) {
    #rec674800315 .t396__artboard {
    }
    #rec674800315 .t396__filter {
    }
    #rec674800315 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 639px) {
    #rec674800315 .t396__artboard {
    }
    #rec674800315 .t396__filter {
    }
    #rec674800315 .t396__carrier {
      background-attachment: scroll;
    }
  }
  @media screen and (max-width: 479px) {
    #rec674800315 .t396__artboard {
      height: 60px;
    }
    #rec674800315 .t396__filter {
      height: 60px;
    }
    #rec674800315 .t396__carrier {
      height: 60px;
      background-attachment: scroll;
    }
  }
  #rec674800315 .tn-elem[data-elem-id="1701164464731"] {
    color: #006eff;
    text-align: center;
    z-index: 2;
    top: 70px;
    left: calc(50% - 600px + 320px);
    width: 561px;
  }
  #rec674800315 .tn-elem[data-elem-id="1701164464731"] .tn-atom {
    color: #006eff;
    font-size: 41px;
    font-family: "TildaSans", Arial, sans-serif;
    line-height: 1.1;
    font-weight: 700;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 1199px) {
  }
  @media screen and (max-width: 959px) {
  }
  @media screen and (max-width: 639px) {
  }
  @media screen and (max-width: 479px) {
    #rec674800315 .tn-elem[data-elem-id="1701164464731"] {
      top: -3px;
      left: calc(50% - 160px + 54px);
      width: 212px;
    }
    #rec674800315 .tn-elem[data-elem-id="1701164464731"] .tn-atom {
      font-size: 28px;
    }
  }
  #rec674785530 .t585__title {
    font-size: 20px;
  }
  #rec674785530 .t585__text {
    font-size: 20px;
  }
  
  #rec673857777 .t420__title {
    color: #525252;
  }
  #rec673857777 .t420__descr {
    color: #ffffff;
  }
  #rec673857777 .t420__logo-link {
    font-size: 20px;
    color: #ffffff;
    text-transform: uppercase;
  }
  #rec673857777 .t420__logo {
    font-size: 20px;
    color: #ffffff;
    text-transform: uppercase;
  }
  .gpt_svg_plus {
    width: 24px !important;
    height: 24px !important;
  }
  
  .t585__lines svg {
    width: 24px !important;
    height: 24px !important;
    vertical-align: text-bottom !important;
  }
  .tilda_input_check{
    color: rgb(0, 0, 0);
      border: 1px solid rgb(0, 0, 0);
      background-color: rgb(255, 255, 255);
      font-size: 22px;
      font-weight: 400;
      height: 70px;
      padding: 0 20px;
      line-height: 1.33;
      width: 100%;
      box-sizing: border-box;
      outline: none;
      -webkit-appearance: none;
      border-radius: 0;
      width: 306px;
      opacity: 0.8;
      font-family: 'TildaSans',Arial,sans-serif;
  }
  .tn-atom__inputs-wrapp{
    display: flex;
    gap:10px;
  }
  .btn_try{
    padding: 0px 15px;
      display: block;
      width: 200px;
      font-weight: 600;
      height: 70px;
      color: #ffffff;
      border-radius: 10px;
      font-size: 24px;
      font-family: TildaSans;
      cursor: pointer;
      background-color: #006eff;
      transition: 0.3s ease all;
      border: none;
      line-height: normal;
  }
  .btn_try:hover{
    background-color: #0f00bc;
  }
  @media screen and (max-width: 479px) {
    .tilda_input_check {
      color: rgb(0, 0, 0);
      border: 1px solid rgb(0, 0, 0);
      background-color: rgb(255, 255, 255);
      font-size: 16px;
      font-weight: 400;
      height: 40px;
    }
    .tn-atom__inputs-wrapp{
      flex-direction: column;
      gap:10px
    }
    .btn_try {
      padding: 0px 15px;
      display: block;
      width: 200px;
      font-weight: 600;
      height: 40px;
      margin-left: auto;
      margin-right: auto;
      color: #ffffff;
      border-radius: 40px;
      font-size: 16px;
      font-family: TildaSans;
      cursor: pointer;
      background-color: #0f00bc;
      transition: 0.3s ease all;
    }
  }
  .show_emails{
    color: red;
  }
  .false_emails{
    color: red;
    position: absolute;
  }
  .some_class{
    list-style: initial;
  }
  .click_btn{
    cursor: pointer;
  }
  .href_privacy{
    color: #ababab !important;
    text-decoration: underline !important;
    cursor:pointer !important;
  }
  .href_policy{
    color: rgb(255, 255, 255) !important;
    text-decoration: underline !important;
    cursor:pointer !important;
  }
  .buy_sending_input{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }
  .buy_sending{
    color: #ababab;
    font-size: 14px;
    font-family: 'Arial',Arial,sans-serif;
    line-height: 22px;
    font-weight: 400;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }
  @media screen and (max-width: 479px) {
      .buy_sending{
        text-align: center;
        font-size: 12px;
        width: 221px;
      }
      .buy_sending_input{
        gap: 13px;
      }
  }
.links_underline:hover{
  text-decoration: underline !important;
  cursor:pointer !important;
}
  </style>
  